import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { AuthService } from './../auth/auth.service';
import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
// import { Jsonp } from '@angular/http/src/http';
// import { window } from 'rxjs/operators/window';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { SelectionModel} from '@angular/cdk/collections';
// import { URLSearchParams } from "@angular/http";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DialogOverviewExampleDialogComponent } from '../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
// import { UseragreementComponent } from '../useragreement/useragreement.component';
// import { concat } from 'rxjs/operator/concat';

@Component({
  selector: 'app-mrfd',
  templateUrl: './mrfd.component.html',
  styleUrls: ['./mrfd.component.css'],
})
export class MrfdComponent implements OnInit {


  selectedIndex: number = 0;
  newselectedIndex: number = 0;
  newEventId: number;
  newProjId: number;
  modval: any;
  usrLists: any;
  rewval: any;
  projLists: any;
  freshAir: any;
  buildEnv: any;
  lightData: any;
  hvData: any;
  value: any;
  seven: number = 7;
  selectedValue = [];
  array: any;
  roof = [];
  floor = [];
  windown = [];
  shading = [];
  lighting = [];
  wwrnew = [];
  wwrValue = [];
  arrayshading: any;
  arraywwr: any;
  arrayroof: any;
  arrayfloor: any;
  arraywindow: any;
  arraylighting: any;
  arrayInf: any;
  heightloadmore: boolean;
  ashtr: boolean;
  nbcf: boolean;
  custv: boolean;
  contentEditable: boolean = true;
  wall = [];
  wallValue = [];
  floorValue = [];
  windCost: any;
  windCostValue: any;
  solarCostValue: any;
  wwrValStr: string;
  solarCost: any;
  solarArea: string | number | boolean;
  solarEffi: string | number | boolean;
  solarAzi: string | number | boolean;
  solarIncl: string | number | boolean;
  btntxt: string = 'Load all WINDOW';
  renewKw: string | number | boolean;
  renewHub: string | number | boolean;
  renewWind: any;
  renewEffi: any;
  solarYn = 'Yes';
  solarYnWin = 'Yes';
  wCv: any;
  sCv: any;
  currentEvent: any;
  newUserId: number;
  currentId: number;
  labelText: string;
  roofValue = [];
  windowValue = [];
  windowValStr: string;
  roofValStr: string;
  floorValStr: string;
  wallValStr: string;
  lightingVal = [];
  lightingValSens = [];
  hvacVal = [];
  heatRec = [];
  dcv = [];
  heatEffect = 10;
  coolEffect = 20;
  message: string;
  ashre = 'ASHRAE 62.1';
  option: string;
  newOptionMsg: string;
  customV: any;
  newcustValue: string;
  newpvValue: string;
  neweffValue: string;
  newwindValue: string;
  effivalue = 100;
  nrtVal: string;
  newinletTemp: string;
  newoutletTemp: string;
  newdhwSource: string;
  newefficency: string;
  selectedfreshValue: any;
  newrequirement: string;
  selectedCustBase = 'selct';
  selectedCustBaseRoof = 'selctroof';
  selectedCustBaseFloor = 'selctfloor';
  selectedCustBasewin = 'selctWin';
  selectedCustBaseShading = 'selctShading';
  selectedCustBaseWWR = 'selctrWWR';
  selectedCustBaseLight = 'selctLight';
  selectedCustBaseDaylight = 'selctDaylight';
  selectedCustBaseHvac = 'selctHvac';
  selectedCustBaseHeatRec = 'YES';
  contentEditableRen: boolean = false;
  contentEditableWin: boolean = false;
  contentEditableHw: boolean = false;
  contentEditableHvac: boolean = false;
  animal: string;
  name: string;
  ebmbededCode: any;
  neweffi: any;
  SolarChanged = 'N';
  WindChanged = 'N';
  DhwChanged = 'N';
  FreshAirChanged = 'N';
  HeatEffChanged = 'N';
  WindEnabled = 'N';
  SolarEnabled = 'N';
  DhwEnabled = 'N';
  condId: string | number | boolean;
  freshAirList: any;
  disbwall: any;
  disbwallN: any;
  disbwallR: any;
  disbwallNR: any;
  disbwallF: any;
  disbwallNF: any;
  disbwallW: any;
  disbwallNW: any;
  disbwallS: any;
  disbwallL: any;
  disbwallNL: any;
  disbwallD: any;
  disbwallND: any;
  disbHvacAsh: any;
  disbHvacNec: any;
  Dls = [];
  arraydls: any;
  HvacNw = [];
  arrayHvac: any;
  heatRecNew = [];
  ynarry = [];
  arrayheatRecNew: any;
  rootDomainUrl: string;
  orgid: any;
  orgidfirst: any;
  newhvData: { projLists: string | any[] };
  necbwwr: string;
  necbWwrVal: string;
  cbWwr: any;
  w1: string;
  w2: string;
  w3: string;
  w4: string;
  w5: string;
  w6: string;
  w7: string;
  r1: string;
  r2: string;
  r3: string;
  r4: string;
  r5: string;
  f1: string;
  f2: string;
  f3: string;
  ashraewall: any;
  necbwall: any;
  ashraeroof: any;
  necbroof: any;
  ashraefloor: any;
  necbfloor: any;
  ret: any;
  cbWall: any;
  cbRoof: any;
  cbFloor: any;
  cbWindow: any;
  cbLight: any;
  cbShading: any;
  cbDls: any;
  cbHvac: any;
  dhw: {
    inletTemp: string;
    outletTemp: string;
    requirement: string;
    efficiency: number;
    dhw_cost: any;
    isSelected: string;
  };
  isUpdated: boolean = false;
  recCount: { percentage: any; time: any; num_records: string | any[] };
  percent: number;
  time: number;
  newIsUpdated: any = 'N';
  efficency: any;
  solarPvData: any;
  dhwData: any;
  windPowerData: any;
  proEne: any;
  proSnk: any;
  frAir: any;
  isDhwSelected: boolean = false;
  isSolarSelected: boolean = false;
  isWindSelected: boolean = false;
  solarToggleChanged: boolean = false;
  windToggleChanged: boolean = false;
  dhwToggleChanged: boolean = false;
  heat: string;
  cool: string;
  boilerCOP: string;
  chillerCOP: string;
  isLoading: boolean = true;
  keycount: any = 0;
  defv: number;
  defaultId: any;
  newEmail: string;
  messagenew: string;
  projData: any;
  isProjectPresent: boolean = true;
  changed: boolean = false;
  windchangedNew: boolean = false;
  changeDomestic: boolean = false;
  firstLoginNew = 'N';
  windToggleChangedFlag: string | number | boolean;
  solarToggleChangedFlag: string | number | boolean;
  wwrVal = '"';
  hvacValStr = '"';
  hvDataPrimary : any = [];
  hvDataSec = [];
  mainHtgFuelSrc = '';
  bkupHtgFuelSrc = '';
  mainHtgFuelSrc1 = '';
  bkupHtgFuelSrc1 = '';
  selectedCustBaseHvacSec = '';
  flowPrimary = '';
  flowSec = '';
  freshAirPrim = [];
  freshAirSec = [];
  frAirCbPrim = '';
  frAirCbSec = '';
  heatCbPrim = '-';
  coolCbPrim = '-';
  heatCbSec = '0';
  coolCbSec = '0';
  heatCOPPrim = '-';
  coolCOPPrim = '-';
  baselineSec = '';
  heatCOPSec = '';
  coolCOPSec = '';
  fuelSrcSec = 'Natural Gas';
  fuelSrcPrim = 'Natural Gas';
  selectedCustBaseInf = 'selctInf';
  inf = [];
  infVal = [];
  infData: any;
  ashraeInf: any;
  necbInf: any;
  proposedLight: any;
  refLight: any;
  dhwCost: any;
  selectedCustBaseHvacName: any;
  selectedCustBaseHvacSecName: any;
  isPrimary: boolean = true;
  custDHW: any;
  srcCust: any;
  effCust: any;
  tediOptionsData:any;
  tedi: boolean = false;
  energy:boolean = true;
  humidification : any;
  humAvlbl : any;
  humCost:any;
  humFuelSourceCust:any ;
  hideArr: any = [];
  allWallSel: any = '';
  allRoofSel: any = '';
  allFloorSel: any = '';
  allWindowSel: any = '';
  allInfSel: any = '';
  allShadingSel: any = '';
  allWwrSel: any = '';
  allDlsSel: any = '';
  allHvacSel: any = '';
  @ViewChildren('wallInput') wallInput: QueryList<any>;
  @ViewChildren('roofInput') roofInput: QueryList<any>;
  @ViewChildren('floorInput') floorInput: QueryList<any>;
  @ViewChildren('windowInput') windowInput: QueryList<any>;
  @ViewChildren('shdInput') shdInput: QueryList<any>;
  @ViewChildren('wwrInput') wwrInput: QueryList<any>;
  @ViewChildren('infInput') infInput: QueryList<any>;
  @ViewChildren('hvacInput') hvacInput: QueryList<any>;
  @ViewChildren('heatInput') heatInput: QueryList<any>;
  @ViewChildren('dlsInput') dlsInput: QueryList<any>;

  folders = [
    {
      name: 'W1',
      updated: 0.95,
      checkedval: true,
      disabled: true,
    },
    {
      name: 'W2',
      updated: 1.2,
      checkedval: false,
      disabled: false,
    },
    {
      name: 'W3',
      updated: 1.5,
      checkedval: true,
      disabled: false,
    },
  ];

  Roof = [
    {
      name: 'R1',
      updated: 0.95,
    },
    {
      name: 'R2',
      updated: 1.2,
    },
    {
      name: 'R3',
      updated: 1.5,
    },
  ];

  Floor = [
    {
      name: 'F1',
      updated: 0.95,
    },
    {
      name: 'F2',
      updated: 1.2,
    },
    {
      name: 'F3',
      updated: 1.5,
    },
  ];

  Windown = [
    {
      name: 'Win 1',
      updated: 0.95,
      upval: 0.15,
    },
    {
      name: 'Win 2',
      updated: 1.2,
      upval: 4.25,
    },
    {
      name: 'Win 3',
      updated: 1.5,
      upval: 6.45,
    },
  ];

  Shading = [
    {
      name: 'Yes',
    },
    {
      name: 'No',
    },
    {
      name: 'Design',
    },
  ];

  wwr = [
    {
      name: '10%',
    },
    {
      name: '20%',
    },
    {
      name: 'Design',
    },
  ];

  Lighting = [
    {
      name: 'LPD1',
      updated: 0.95,
    },
    {
      name: 'LPD2',
      updated: 1.2,
    },
    {
      name: 'LPD3',
      updated: 1.5,
    },
  ];

  Daylight = [
    {
      name: 'YES',
    },
    {
      name: 'NO',
    },
  ];

  Hvac = [
    {
      name: 'VAV with Reheat',
      updated: 0.95,
      upval: 0.15,
    },
    {
      name: 'Water to Air Heat Pump',
      updated: 1.2,
      upval: 4.25,
    },
    {
      name: 'DOAS FCU',
      updated: 1.5,
      upval: 6.45,
    },
  ];

  Heat = [
    {
      name: 'YES',
    },
    {
      name: 'NO',
    },
  ];

  Dcv = [
    {
      name: 'YES',
    },
    {
      name: 'NO',
    },
  ];

  /*  building = [
    {text: 'M2', color: 'lightblue'},
    {text: '540', color: 'lightgreen'},
    {text: '144', color: 'lightpink'},
    {text: '77', color: '#DDBDF1'},
    {text: '80', color: '#DDBDF1'},
    {text: '376', color: '#DDBDF1'}

  ]; */
  tiles = [
    { text: 'Winnipeg', color: 'lightblue' },
    { text: 'Canada', color: 'lightgreen' },
    { text: 'Service Apt', color: 'lightpink' },
    { text: '24 hrs', color: '#DDBDF1' },
    { text: '80', color: '#DDBDF1' },
    { text: '376', color: '#DDBDF1' },
  ];
  selectedWall = [];
  wallLen = 0;
  selectedRoof = [];
  roofLen = 0;
  selectedFloor = [];
  flrLen = 0;
  selectedShad = [];
  shadLen = 0;
  selectedWin = [];
  winLen = 0;
  selectedWwr = [];
  wwrLen = 0;
  selectedInf = [];
  infLen = 0;
  selectedDls = [];
  dlsLen = 0;
  selectedHvac = [];
  hvacLen = 0;
  allSelected=false;
  selectedHeat = [];
  heatLen = 2;
  allHeatSel: any;
  wallSel: any = '';
  roofSel: any = '';
  floorSel: any = '';
  windowSel: any = '';
  infSel: any = '';
  dlsSel: any = '';
  shdSel: any = '';
  wwrSel: any = '';
  hvacSel: any = '';
  heatSel: any = '';
  catCustData: any;
  custName: any = '';
  actualName: any;
  newcustHtRec: string="Y";

  change(e, type) {
    //console.log(type);
    if (e.checked) {
      this.selectedValue.push(type);
    }
  }
  toggleAll(event: MatCheckboxChange) {
    if ( event.checked ) {
        if(event.source.id == 'wallCheck') {
          this.wallSel = '';
          this.wall = [];
            this.buildEnv.projLists.forEach(row => {
                if(row?.wall) {
                // console.log('checked row', row);
                this.wallSel = this.wallSel+','+row.wall;
                if(!this.selectedWall.includes(row))
                this.selectedWall.push(row);
                this.wall.push(
                  '"' + row.wall_r_value_ip + '"'
                );
               
                }
              });
              
              console.log((this.array = 'wall' + '=' + this.wall));
//              this.authService.changeSelectedWall(this.selectedWall);
            // console.log('checked here');
        } else if(event.source.id == 'roofCheck') {
          this.roof = [];
          this.roofSel = '';
          this.buildEnv.projLists.forEach(row => {
              if(row?.roof) {
              // console.log('checked row', row);
              if(!this.selectedRoof.includes(row))
              this.selectedRoof.push(row);
              this.roofSel = this.roofSel+','+row.roof;
              this.roof.push(
                '"' + row.roof_r_value_ip + '"'
              );
              }
            });
            console.log((this.arrayroof = 'roof' + '=' + this.roof)); 

      } else if(event.source.id == 'floorCheck') {
        this.floorSel = '';
        this.floor = [];
        this.buildEnv.projLists.forEach(row => {
            if(row?.floor) {
            // console.log('checked row', row);
            if(!this.selectedFloor.includes(row))
            this.selectedFloor.push(row);
            this.floorSel = this.floorSel+','+row.floor;
            this.floor.push(
              '"' + row.floor_r_value_ip + '"'
            );
            }
          });
          console.log(
            (this.arrayfloor =
              'floor' + '=' + decodeURI(this.floor.toString().trim()))
          );      
      }  else if(event.source.id == 'winCheck') {
        this.windowSel = '';
        this.windown = [];
        this.buildEnv.projLists.forEach(row => {
            if(row?.windows) {
            // console.log('checked row', row);
            if(!this.selectedWin.includes(row))
            this.selectedWin.push(row);
            this.windowSel = this.windowSel+','+row.windows;
            this.windown.push(
              '"' + row.win_r_value_ip + '"'
            );
            }
          });
          console.log((this.arraywindow = 'window' + '=' + this.windown.join("|")));
          console.log('this.windowSel'+this.windowSel);
      } else if(event.source.id == 'shadCheck') {
        this.shdSel = '';
        this.shading = [];
        this.buildEnv.projLists.forEach(row => {
            if(row?.shading) {
            // console.log('checked row', row);
            if(!this.selectedShad.includes(row))
            this.selectedShad.push(row);
            this.shdSel = this.shdSel+','+row.shading;
            this.shading.push(
              '"' + row.shading + '"'
            );
            }
          });
          console.log((this.arrayshading = 'shading' + '=' + this.shading));
      } else if(event.source.id == 'wwrCheck') {
        this.wwrSel = '';
        this.wwrnew = [];
        let wwr: any;
        this.buildEnv.projLists.forEach(row => {
            if(row.wwr_percentage !== '0' && row.wwr_percentage !== undefined) {
            // console.log('checked row', row);
            if(!this.selectedWwr.includes(row))
            this.selectedWwr.push(row);
            if(row.wwr_percentage.indexOf('%') > -1) {
              this.wwrSel = this.wwrSel+','+(row.wwr_percentage.replace('%', '') / 100).toFixed(3);
              wwr = (row.wwr_percentage.replace('%', '') / 100).toFixed(3);
            }
            else 
              this.wwrSel = this.wwrSel+','+row.wwr_percentage;
           
            this.wwrnew.push(
              '"' + wwr + '"'
            );
            }
          });
          console.log((this.arraywwr = 'wwr' + '=' + this.wwrnew));
      } else if(event.source.id == 'infCheck') {
        this.infSel = '';
        this.inf = [];
        this.infData.projLists.forEach(row => {
            if(row?.inf) {
            // console.log('checked row', row);
            if(!this.selectedInf.includes(row))
            this.selectedInf.push(row);
            this.infSel = this.infSel+','+row.inf;
            this.inf.push(
              '"' + row.infiltration_ref + '"'
            );
            }
          });
          console.log((this.arrayInf = 'inf' + '=' + this.inf));
      } else if(event.source.id == 'dlsCheck') {
        this.dlsSel = '';
        this.Dls = [];
        this.lightData.projLists.forEach(row => {
            if(row?.daylight_sensor) {
            // console.log('checked row', row);
            if(!this.selectedDls.includes(row))
            this.selectedDls.push(row);
            this.dlsSel = this.dlsSel+','+row.daylight_sensor;
            if (row.daylight_sensor == 'YES') {
              this.Dls.push(
                '"' + 'DLON' + '"'
              );
            }
           else if (row.daylight_sensor == 'NO') {
              this.Dls.push(
                '"' + 'DLOFF' + '"'
              );
            }
            }
          });
          console.log((this.arraydls = 'dl' + '=' + this.Dls));
      } else if(event.source.id == 'hvacCheck') {
        this.hvacSel = '';
        this.hvacVal = [];
        this.hvDataPrimary.forEach(row => {
            if(row?.HVAC_system) {
            // console.log('checked row', row);
            if(!this.selectedHvac.includes(row))
            this.selectedHvac.push(row);
            this.hvacSel = this.hvacSel+','+row.HVAC_system;
            this.hvacVal.push(
              '"' + row.HVAC_system + '"'
            );
            }
          });
          console.log(
            (this.arrayHvac =
              'hvac' + '=' + (this.hvacVal.toString()))
          );
      } else if(event.source.id == 'heatCheck') {
        this.heatSel = '';
        this.arrayheatRecNew = 'heatRecovery' + '=';
       if(!this.selectedHeat.includes('Y')) {
       this.selectedHeat.push(this.freshAirList?.refData?.YES);
       this.arrayheatRecNew = this.arrayheatRecNew+'"' + this.freshAirList?.refData?.YES + '"';
       }
        if(!this.selectedHeat.includes('N')) {
       this.selectedHeat.push(this.freshAirList?.refData?.NO);
       this.arrayheatRecNew = this.arrayheatRecNew+"|"+'"' + this.freshAirList?.refData?.NO + '"';
        }
       
        this.heatSel = 'Y'+','+'N';
        // console.log('checked here');
      } 
      }  else  {
        // console.log('checked false');
        if(event.source.id == 'wallCheck') {
          this.selectedWall = [];
          this.wallSel = '';
        }
        else if(event.source.id == 'roofCheck') {
          this.selectedRoof = [];
          this.roofSel = '';
        }
        else if(event.source.id == 'floorCheck') {
          this.selectedFloor = [];
          this.floorSel = '';
        }
        else if(event.source.id == 'winCheck') {
          this.selectedWin = [];
          this.windowSel = '';
        }
        else if(event.source.id == 'shadCheck') {
          this.selectedShad = [];
          this.shdSel = '';
        }
        else if(event.source.id == 'wwrCheck') {
         this.selectedWwr = [];
         this.wwrSel = '';
        }
        else if(event.source.id == 'infCheck') {
          this.selectedInf = [];
          this.infSel = '';
        }
        else if(event.source.id == 'dlsCheck') {
          this.selectedDls = [];
          this.dlsSel = '';
        }
        else if(event.source.id == 'hvacCheck') {
          this.selectedHvac = [];
          this.hvacSel = '';
        }
        else if(event.source.id == 'heatCheck')  {
          this.selectedHeat = [];
          this.heatSel = '';
        }
      }
      console.log(' toggleAll '+this.selectedWall.length);
  }
  toggleHeat(event: MatCheckboxChange) {
    if ( event.checked ) {
        if(event.source.id == 'heatRecCheckY') {
            
        } 
      } 

  }
  materialApi() {
    this.authService.solarPvCalc().subscribe((data) => {
      this.solarPvData = data;
    });
    //to be uncommented later
    // this.authService.dhwCalc().subscribe((data) => {
    //    this.dhwData = data;
    //})
    this.authService.windPowerCalc().subscribe((data) => {
      this.windPowerData = data;
    });

    this.authService.proEnergy().subscribe((data) => {
      this.proEne = data;
    });

    this.authService.proSankey().subscribe((data) => {
      this.proSnk = data;
    });

    this.authService.freshAirList().subscribe((data) => {
      this.frAir = data;
    });
  }

  clickMeForward() {
    this.selectedIndex++;

    /* if(event.srcElement.id == "rentop") {
      this.uploadReneablesTemp();
    } */
    // alert(this.labelText)

    if (this.labelText == 'Domestic Hot Water') {
      var effi = document.getElementById('inletTemp').innerText;
      this.authService.changeinletTemp(effi);

      var renew = document.getElementById('outletTemp').innerText;
      this.authService.changeoutletTemp(renew);
      // this.authService.changewindValue(renew)

      var efciy = document.getElementById('efciy').innerText;
      this.authService.changeefficency(efciy);

      var ultra = (<HTMLInputElement>document.getElementById('Ultra')).value;
      this.authService.changedhwSource(ultra);

      var requi = document.getElementById('requirement').innerText;
      this.authService.changerequirement(requi);

      /*var source = (<HTMLInputElement>document.getElementById('switch2')).checked;
 if(source == true) {
	this.authService.changeToggleStatusDhw("false");
 } else {
	 this.authService.changeToggleStatusDhw("true");
 } */
      this.authService.changeToggleStatusDhw('true');
    }

    if (this.labelText == 'Renewables') {
      var renewH = document.getElementById('renewKwH').innerText;
      this.authService.changewindValue(renewH);

      var pv = document.getElementById('heateng').innerText;
      this.authService.changepvValue(pv);

      var effi = document.getElementById('solarEffi').innerText;
      this.authService.changeeffValue(effi);

      var source = (<HTMLInputElement>document.getElementById('switch'))
        .checked;
      if (source == true) {
        this.authService.changetoggleStatus('false');
      } else {
        this.authService.changetoggleStatus('true');
      }
      var sourceWind = (<HTMLInputElement>document.getElementById('switch1'))
        .checked;
      if (sourceWind == true) {
        this.authService.changetoggleStatusWind('false');
      } else {
        this.authService.changetoggleStatusWind('true');
      }
      this.materialApi();
    }
    if (this.labelText == 'Renewables') {
      this.uploadReneablesTemp();
    }
    if (this.labelText == 'Domestic Hot Water') {
      var inletTemp = document.getElementById('inletTemp').innerText;
      this.authService.changeinletTemp(renewH);

      var outletTemp = document.getElementById('outletTemp').innerText;
      this.authService.changeoutletTemp(outletTemp);

      var req = document.getElementById('requirement').innerText;
      this.authService.changerequirement(req);
      var src = (document.getElementById('Ultra') as HTMLInputElement).value;
      this.authService.changedhwSource(src);
      var eff = document.getElementById('efciy').innerText;
      this.authService.changeefficency(eff);
    }
  }

  clickMeBack() {
    this.selectedIndex--;
  }
  selectedIndexChange(val: number) {
    this.selectedIndex = val;
    
  }

  clickMeSubForward() {
    this.newselectedIndex++;
    this.custBase();
    this.CustBaseRoof();
    this.CustBaseFloor();
    this.CustBaseWindow();
    this.CustBaseShading();
    this.CustBaseLighting();
    this.CustBaseInf();
    this.CustBaseWwr();
    this.CustBaseDaylight();
    this.CustBaseHvac();
    if (this.labelText == 'Fresh Air & Heat Recovery') {
      var frear = document.getElementById('frair').innerText;

      this.authService.changecustValue(frear);

      var a = document.getElementsByClassName('freshAirDhw');
      var i = a[0].id;
      if (i == 'nbc') {
        this.authService.changeOptionMessage('NECB');
      } else if (i == 'ashr') {
        this.authService.changeOptionMessage('ASHRAE');
      } else if (i == 'custom') {
        this.authService.changeOptionMessage('CUSTOM');
      }
    }
    /*this.authService.freshAirCalc().subscribe((data) => {
          this.efficency = data;
         
    })*/
  }
  clickMeSubForwardNext() {
    this.clickMeSubForward();
    this.uploadBuildingEnvelop();
  }
  clickMeSubForwardLighting() {
    this.clickMeSubForward();
    this.uploadLighting();
  }
  clickMeSubBack() {
    this.newselectedIndex--;
  }
  NewselectedIndexChange(val: number) {
    this.newselectedIndex = val;
  }
  constructor(
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
    public dialog: MatDialog
  ) {}

  loadMore() {
    //  this.heightloadmore = true;
    /*  if(this.seven == 7){
     this.seven = 12;
     this.btntxt =  "Load 7 WIN";
     }
     else if(this.seven == 12){
      this.seven = 7;
      this.btntxt =  "Load all WIN";
      } */
    if (this.btntxt == 'Load all WINDOW') {
      document.getElementById('windw').style.height = 'auto';
      // this.heightloadmore = false;
    } else if (this.btntxt == 'Load 7 WINDOW') {
      document.getElementById('windw').style.height = '580px';
      this.btntxt = 'Load all WINDOW';
      // this.heightloadmore = true;
    }
  }
  toggleEditable(event) {
    if (event.checked) {
      this.contentEditable = true;
      this.authService.changeToggleEditable('true');
    } else {
      this.contentEditable = false;
      this.authService.changeToggleEditable('false');
    }
  }

  goHome() {
    //this.router.navigate(['chart']);

    //this.CustBaseHtRec();
    /* this.authService.freshAirCalc().subscribe((data) => {
          this.efficency = data;
        
    })*/
    if (this.newEmail !== 'demo@ecomatrix.io') {
      this.updateHeatCoolInter();
    }

   

    if(this.selectedWall?.length == 0) {
      this.array = this.allWallSel;
      this.authService.addtoHideArr('WALL');
    }
    if(this.selectedRoof?.length == 0) {
      this.arrayroof = this.allRoofSel;
      this.authService.addtoHideArr('ROOF');
    }
    if(this.selectedFloor?.length == 0) {
      this.arrayfloor = this.allFloorSel;
      this.authService.addtoHideArr('FLOOR');
    }
    if(this.selectedWin?.length == 0) {
      this.arraywindow = this.allWindowSel;
      this.authService.addtoHideArr('WINDOW');
    }
    if(this.selectedShad?.length == 0) {
      this.arrayshading = this.allShadingSel;
      this.authService.addtoHideArr('SHADING');
    }
    if(this.selectedWwr?.length == 0) {
      this.arraywwr = this.allWwrSel;
      this.authService.addtoHideArr('WWR');
    }
    if(this.selectedInf?.length == 0) {
      this.arrayInf = this.allInfSel;
      this.authService.addtoHideArr('INFILTRATION');
    }
    if(this.selectedDls?.length == 0) {
      this.arraydls = this.allDlsSel;
      this.authService.addtoHideArr('DL');
    } 
    if(this.selectedHvac?.length == 0) {
      this.arrayHvac = this.allHvacSel;
      this.authService.addtoHideArr('HVAC');
    } 
    if(this.selectedHeat?.length == 0) {
      this.arrayheatRecNew = this.allHeatSel;
      this.authService.addtoHideArr('HEAT');
    } 
    this.newMessage();

    if(this.selectedWall?.length == 0 &&
      this.selectedRoof?.length == 0 &&
      this.selectedFloor?.length == 0 &&
      this.selectedWin?.length == 0 &&
      this.selectedShad?.length == 0 &&
      this.selectedDls?.length == 0 &&
      this.selectedInf?.length == 0 &&
      this.selectedHvac?.length == 0 &&
      this.selectedHeat?.length == 0)
      {
        //alert('None of the variables are selected for analysis. Please select the applicable variable categories to be able to proceed further.');

        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
          position: ({top: "5%"}),
          data: { isCost: true },
          //width: "30vw"
        });

      } else {

        if (this.isUpdated == true) {
          const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
            // height: '500px',
            position: ({top: "5%"}),
            data: { isCost: false },
            //width: "30vw"
          });
          this.percent = 0;
          this.time = 10;
        }

        if (this.isUpdated == false) {
          const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
            position: ({top: "5%"}),
            data: { isCost: false },
            //width: "30vw"
          });
        }
      }

  }

  
  checkValWall() {
    this.wall = [];
    this.wallInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.wall.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if(this.wall.length > 0) {
    this.allWallSel = 'wall' + '=' + this.wall[0];
    console.log((this.array = 'wall' + '=' + this.wall));
    }
  }

  checkValNewWall(item,event: MatCheckboxChange) {
    this.wall = [];
    
    this.wallInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.wall.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );

    if (event.checked) {
      if(!this.selectedWall.includes(item)) {
        this.selectedWall.push(item);
        
      }
      if(this.wallSel.indexOf(item.wall) == -1)
        this.wallSel = this.wallSel + ',' + item.wall;
      } else {
        const index = this.selectedWall.indexOf(item);
        if (index >= 0) {
          this.selectedWall.splice(index, 1);
        }
        this.wallSel = this.wallSel.replace(item.wall,'');
      }
   // this.authService.changeSelectedWall(this.selectedWall);
   console.log(item + "<>", event.checked);
    console.log((this.array = 'wall' + '=' + this.wall));
    this.newMessage();
    console.log(' checknew wall '+this.selectedWall.length);
  }

  existsWall(item,event: MatCheckboxChange) {
    if(event?.source.id == 'wallCheck1' || event == undefined)
      return (this.wallSel.indexOf(item.wall) > -1) ;
  };
  existsFloor(item,event: MatCheckboxChange) {
    if(event?.source.id == 'floorCheck1' || event == undefined)
      return (this.floorSel.indexOf(item.floor) > -1) ;
  };
  existsWin(item,event: MatCheckboxChange) {
    if(event?.source.id == 'winCheck1' || event == undefined)
      return (this.windowSel.indexOf(item.windows) > -1) ;
  };
  existsShad(item,event: MatCheckboxChange) {
    if(event?.source.id == 'shadCheck1' || event == undefined)
      return (this.shdSel.indexOf(item.shading) > -1) ;
  };
  existsWwr(item,event: MatCheckboxChange) {
    if(event?.source.id == 'wwrCheck1' || event == undefined)
      return ((this.wwrSel).indexOf((item.wwr_percentage.replace('%', '') / 100).toFixed(3)) > -1) ;
  };
  existsRoof(item,event: MatCheckboxChange) {
    if(event?.source.id == 'roofCheck1' || event == undefined)
      return (this.roofSel.indexOf(item.roof) > -1) ;
  };
  existsInf(item,event: MatCheckboxChange) {
    if(event?.source.id == 'infCheck1' || event == undefined)
      return (this.infSel.indexOf(item.inf) > -1) ;
  };
  existsDls(item,event: MatCheckboxChange) {
    if(event?.source.id == 'dlsCheck1' || event == undefined)
      return (this.dlsSel.indexOf(item.daylight_sensor) > -1) ;
  };
  existsHvac(item,event: MatCheckboxChange) {
    if(event?.source.id == 'hvacCheck1' || event == undefined)
      return (this.hvacSel.indexOf(item.HVAC_system) > -1) ;
  };
  existsHeatRec(item) {
    //if(event?.source.id == 'heatRecCheck' || event == undefined)
      return (this.heatSel.indexOf(item) > -1) ;
  }
  isCheckedWall() {
      return this.selectedWall.length === this.wallLen;
  };
  isCheckedRoof() {
     return this.selectedRoof.length === this.roofLen;
   };
  isCheckedFloor() {
    return this.selectedFloor.length === this.flrLen;
  };
  isCheckedwin() {
    return this.selectedWin.length === this.winLen;
  };
  isCheckedShad() {
    return this.selectedShad.length === this.shadLen;
  };
  isCheckedWwr() {
    return this.selectedWwr.length === this.wwrLen;
  };
  isCheckedInf() {
    return this.selectedInf.length === this.infLen;
  };
  isCheckedDls() {
    return this.selectedDls.length === this.dlsLen;
  };
  isCheckedHvac() {
    return this.selectedHvac.length === this.hvacLen;
  };
  isCheckedHeat() {
    
    if(this.selectedHeat.length == 2) {
      return true;
    } else {
      return false;
    }
    
  };
  checkValRoof() {
    this.roof = [];
    this.roofInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.roof.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if(this.roof.length > 0) {
      this.allRoofSel = 'roof' + '=' + this.roof[0];
      console.log((this.arrayroof = 'roof' + '=' + this.roof));
    }
    // decodeURI(this.arrayroof.replace(/\s/g, ""))
  }

  checkValNewRoof(item,event) {
    this.roof = [];
    
    this.roofInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.roof.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if (event.checked) {
      if(!this.selectedRoof.includes(item)) 
      this.selectedRoof.push(item);
      if(this.roofSel.indexOf(item.roof) == -1)
        this.roofSel = this.roofSel + ',' + item.roof;

    } else {
      const index = this.selectedRoof.indexOf(item);
      if (index >= 0) {
        this.selectedRoof.splice(index, 1);
      }
      this.roofSel = this.roofSel.replace(item.roof,'');
    }
    console.log((this.arrayroof = 'roof' + '=' + this.roof));
    this.newMessage();
    // decodeURI(this.arrayroof.replace(/\s/g, ""))
  }

  checkValFloor() {
    this.floor = [];
    this.floorInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.floor.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if(this.floor.length > 0) {
      this.allFloorSel = 'floor' + '=' + this.floor[0];
      console.log(
        (this.arrayfloor =
          'floor' + '=' + decodeURI(this.floor.toString().trim()))
      );
    }
    //decodeURI(this.arrayfloor)
  }

  checkValNewFloor(item,event) {
    this.floor = [];
    this.floorInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.floor.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if (event.checked) {
      if(!this.selectedFloor.includes(item)) 
      this.selectedFloor.push(item);
      if(this.floorSel.indexOf(item.floor) == -1)
      this.floorSel = this.floorSel + ',' + item.floor;

    } else {
      const index = this.selectedFloor.indexOf(item);
      if (index >= 0) {
        this.selectedFloor.splice(index, 1);
      }
      this.floorSel = this.floorSel.replace(item.floor,'');
    }
    console.log(
      (this.arrayfloor =
        'floor' + '=' + decodeURI(this.floor.toString().trim()))
    );
    this.newMessage();
  }

  checkValWindow() {
    if (this.buildEnv) {
      this.windown = [];
      this.windowInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.windown.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
      //decodeURI(this.arraywindow)
      //Phase 2.3
      if(this.windown.length > 0) {
        this.allWindowSel  = 'window' + '=' + this.windown[0];
        console.log((this.arraywindow = 'window' + '=' + this.windown.join("|")));
      }
    }
  }

  checkValNewWindow(item,event) {
    if (this.buildEnv) {
      this.windown = [];
      this.windowInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.windown.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
      if (event.checked) {
        if(!this.selectedWin.includes(item)) 
        this.selectedWin.push(item);
        if(this.wallSel.indexOf(item.wall) == -1)
        this.windowSel = this.windowSel + ',' + item.windows;

      } else {
        const index = this.selectedWin.indexOf(item);
        if (index >= 0) {
          this.selectedWin.splice(index, 1);
        }
        this.windowSel = this.windowSel.replace(item.windows,'');
      }
      //decodeURI(this.arraywindow)
      console.log((this.arraywindow = 'window' + '=' + this.windown.join("|")));
      this.newMessage();
    }
  }
  checkAllValue(event: any) {
    this.labelText = event.tab.textLabel;
    this.checkValWall();
    this.checkValRoof();
    this.checkValFloor();
    this.checkValWindow();
    this.checkValShading(null,null);
    this.checkValwwr(null,null);
    
  }
  checkonlylight(tabChangeEvent: MatTabChangeEvent) {
    
    if (this.inf.length == 0) this.checkValInf(null,null);
    if (this.lighting.length == 0) this.checkValLighting();
    if (this.Dls.length == 0) this.checkValDls(null,null);
    if (this.HvacNw.length == 0) this.checkValHvac(null,null);
    if (this.heatRecNew.length == 0) this.checkValHeatRec(null,null);
    if (tabChangeEvent.index == 4) this.isPrimary = true;
    else if (tabChangeEvent.index == 5) this.isPrimary = false;
    if (tabChangeEvent.index == 4 || tabChangeEvent.index == 5)
      this.uploadHvac(this.isPrimary);
  }
  checkValShading(item,event) {
    this.shading = [];
    this.shdInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.shading.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if (event?.checked) {
      if(!this.selectedShad.includes(item)) 
      this.selectedShad.push(item);
      if(this.shdSel.indexOf(item.shading) == -1)
      this.shdSel = this.shdSel + ',' + item.shading;
    } else {
      const index = this.selectedShad.indexOf(item);
      if (index >= 0) {
        this.selectedShad.splice(index, 1);
      }
      this.shdSel = this.shdSel.replace(item?.shading,'');
    }
    //this.shading.pop();
    if(this.shading.length > 0) {
      if(item == null && event == null)
      this.allShadingSel = 'shading' + '=' + this.shading[0];
      console.log((this.arrayshading = 'shading' + '=' + this.shading));
      //console.log(this.arrayshading)
      }
  }

  checkValwwr(item,event) {
    this.wwrnew = [];
    /*var checkboxes = document.querySelectorAll(
      '#wwr input[type=checkbox]:checked'
    );
    
    for (var i = 0; i < checkboxes.length; i++) {
      
      var wwr: any = (checkboxes[i] as HTMLInputElement).value;
      if (wwr.indexOf('%') > 0) {
        wwr = (wwr.replace('%', '') / 100).toFixed();
      }

      //ret = ret/100;
      (checkboxes[i] as HTMLInputElement).value = wwr;

      this.wwrnew.push('"' + (checkboxes[i] as HTMLInputElement).value + '"');
    }*/
    this.wwrInput.forEach((element, index) => 
    {

        if(element.checked) {
          var wwr: any = element.value;
          if (wwr.indexOf('%') > 0) {
            wwr = (wwr.replace('%', '') / 100).toFixed(3);
          }
          this.wwrnew.push('"' + wwr + '"');
        
        }
        }
    );
    if (event?.checked) {
      
        if(!this.selectedWwr.includes(item)) 
          this.selectedWwr.push(item);
        if(this.wwrSel.indexOf(item.wwr_percentage) == -1)
          this.wwrSel = this.wwrSel + ',' + item.wwr_percentage;
  
    } else {
      const index = this.selectedWwr.indexOf(item);
      if (index >= 0) {
        this.selectedWwr.splice(index, 1);
      }
      this.wwrSel = this.wwrSel.replace(item?.wwr_percentage,'');
    }
    if(this.wwrnew.length > 0) {
    if(item == null && event == null)
    this.allWwrSel =  'wwr' + '=' + this.wwrnew[0];
    console.log((this.arraywwr = 'wwr' + '=' + this.wwrnew));
    //console.log(this.arraywwr)
    }
  }

  checkValLighting() {
    this.lighting = [];
    var checkboxes = document.querySelectorAll(
      '#lightingitem input[type=checkbox]:checked'
    );
    for (var i = 0; i < checkboxes.length; i++) {
      if ((checkboxes[i] as HTMLInputElement).value == 'LPD3 (ASH-NECB)') {
        (checkboxes[i] as HTMLInputElement).value = 'LPD3';
      }

      this.lighting.push('"' + (checkboxes[i] as HTMLInputElement).value + '"');
    }
    console.log((this.arraylighting = 'lighting' + '=' + this.lighting));
    
  }
  checkValInf(item,event) {
    this.inf = [];
    this.infInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.inf.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if (event?.checked) {
      if(!this.selectedInf.includes(item)) 
      this.selectedInf.push(item);
      if(this.infSel.indexOf(item.inf) == -1)
      this.infSel = this.infSel + ',' + item.inf;

    } else {
      const index = this.selectedInf.indexOf(item);
      if (index >= 0) {
        this.selectedInf.splice(index, 1);
      }   
		  this.infSel = this.infSel.replace(item?.inf,'');
    }
    if(this.inf.length > 0) {
    if(item == null && event == null)
    this.allInfSel = 'inf' + '=' + this.inf[0];
    console.log((this.arrayInf = 'inf' + '=' + this.inf));
    }
    this.uploadInf();
  }

  checkValDls(item,event) {
    this.Dls = [];
    this.dlsInput.forEach((element, index) => 
    {
        if(element.checked) {
          if (element.value == 'YES') {
            this.Dls.push('"' + 'DLON' + '"');
            }
    
          if (element.value == 'NO') {
            this.Dls.push(
              '"' + 'DLOFF' + '"'
            );
          }

         
        }
        }
    );
    if (event?.checked) {
      if(!this.selectedDls.includes(item)) 
        this.selectedDls.push(item);
      if(this.dlsSel.indexOf(item.daylight_sensor) == -1)
        this.dlsSel = this.dlsSel + ',' + item?.daylight_sensor;

    } else {
      const index = this.selectedDls.indexOf(item);
      if (index >= 0) {
        this.selectedDls.splice(index, 1);
      }
      this.dlsSel = this.dlsSel.replace(item?.daylight_sensor,'');
    }
    if(this.Dls.length > 0) {
    if(item == null && event == null) 
    this.allDlsSel = 'dl' + '=' + this.Dls[0];
    console.log((this.arraydls = 'dl' + '=' + this.Dls));
    }
    //this.uploadLighting();
  }

  checkValHvac(item,event) {
    console.log(' in checkvalhvac ');
    this.HvacNw = [];
    this.hvacInput.forEach((element, index) => 
    {
        if(element.checked) {
          this.HvacNw.push(
            '"' + element.value.trim() + '"'
          );
        }
        }
    );
    if (event?.checked) {
      if(!this.selectedHvac.includes(item)) 
      this.selectedHvac.push(item);
      if(this.hvacSel.indexOf(item.HVAC_system) == -1)
      this.hvacSel = this.hvacSel + ',' + item.HVAC_system;
    } else {
      const index = this.selectedHvac.indexOf(item);
      if (index >= 0) {
        this.selectedHvac.splice(index, 1);
      }
      this.hvacSel = this.hvacSel.replace(item?.HVAC_system,'');
      console.log(this.hvacSel);
    }
    if(this.HvacNw.length > 0) {
        if(item == null && event == null)
        this.allHvacSel =  'hvac' + '=' + (this.HvacNw.toString());
        console.log(
          (this.arrayHvac =
            'hvac' + '=' + (this.HvacNw.toString()))
        );
      }
    //this.uploadHvac();
    this.newMessage();
  }

  checkValHeatRec(item,event: MatCheckboxChange) {
    this.heatRecNew = [];
    this.ynarry = [];
    var checkboxes = document.querySelectorAll(
      '#heatRecCheck input[type=checkbox]:checked'
    );
    for (var i = 0; i < checkboxes.length; i++) {
      this.heatRecNew.push((checkboxes[i] as HTMLInputElement).value);
    }
   
    if(item == null && event == null)
    this.allHeatSel =  'heatRecovery' + '=' + '"' + this.freshAirList?.refData?.YES + '"' + '|' + '"' + this.freshAirList?.refData?.NO + '"';

    console.log(this.heatRecNew.includes('Y') && this.heatRecNew.includes('N'));
    if (this.heatRecNew.includes('Y')) {
      this.arrayheatRecNew = [];
      this.arrayheatRecNew = 'heatRecovery' + '=' + '"' + this.freshAirList?.refData?.YES + '"';
    }
    if (this.heatRecNew.includes('N')) {
      this.arrayheatRecNew = [];
      this.arrayheatRecNew = 'heatRecovery' + '=' + '"' + this.freshAirList?.refData?.NO + '"';
    }
    if ((this.heatRecNew.includes('Y') && this.heatRecNew.includes('N'))
    || (!this.heatRecNew.includes('Y') && !this.heatRecNew.includes('N'))) {
      this.arrayheatRecNew = [];
      this.arrayheatRecNew =
        'heatRecovery' + '=' + '"' + this.freshAirList?.refData?.YES + '"' + '|' + '"' + this.freshAirList?.refData?.NO + '"';
    }
    if (event?.checked) {
      if(!this.selectedHeat.includes(item)) 
      this.selectedHeat.push(item);
      if(this.heatSel.indexOf(item) == -1)
      this.heatSel = this.heatSel + ',' + item;
  

    } else {
      const index = this.selectedHeat.indexOf(item);
      if (index >= 0) {
        this.selectedHeat.splice(index, 1);
      }
      this.heatSel = this.heatSel.replace(item,'');
    }
  }

  onValChange(val) {
    if (val == 'true') {
      this.solarYn = 'Yes';
    } else if (val == 'false') {
      this.solarYn = 'No';
    }

    //alert(this.solarYn)
  }

  onTogValChange(event) {
    this.changed = true;
    this.currentEvent = event.target.checked;
    if (this.isSolarSelected == event.target.checked) {
      this.solarToggleChanged = true;
    } else {
      this.solarToggleChanged = false;
    }
    if (event.target.checked) {
      this.contentEditableRen = false;
      this.authService.changetoggleStatus('false');

      (<HTMLElement>document.querySelector('#heateng')).style.border =
        '1px solid #e8edef';
      (<HTMLElement>document.querySelector('#solarEffi')).style.border =
        '1px solid #e8edef';
    } else {
      this.contentEditableRen = true;
      this.authService.changetoggleStatus('true');

      (<HTMLElement>document.querySelector('#heateng')).style.border =
        '1px solid #dd9b50';
      (<HTMLElement>document.querySelector('#solarEffi')).style.border =
        '1px solid #dd9b50';
    }
  }

  onTogWindValChange(event) {
    this.windchangedNew = true;
    if (this.isWindSelected == event.target.checked) {
      this.windToggleChanged = true;
    } else {
      this.windToggleChanged = false;
    }
    if (event.target.checked) {
      this.contentEditableWin = false;

      this.authService.changetoggleStatusWind('false');
      (<HTMLElement>document.querySelector('#renewKwH')).style.border =
        '1px solid #e8edef';
    } else {
      this.contentEditableWin = true;

      this.authService.changetoggleStatusWind('true');
      (<HTMLElement>document.querySelector('#renewKwH')).style.border =
        '1px solid #dd9b50';
    }
  }
  getId(id): void {
    for (var i = 0; i < this.newhvData.projLists.length; i++) {
      if (id == this.newhvData.projLists[i].HVAC_system) {
        this.chillerCOP = this.newhvData.projLists[i].chillerCOP;
      }
    }
  }

  getIdfirst(id): void {
    for (var i = 0; i < this.newhvData.projLists.length; i++) {
      if (id == this.newhvData.projLists[i].HVAC_system) {
        this.boilerCOP = this.newhvData.projLists[i].boilerCOP;
      }
    }
  }

  toggleMe(id): void {
    var hvacct = id;
    var chillerCOP = document.getElementById('btn-' + id).innerHTML;
    var boilerCOP = document.getElementById('btnnew-' + id).innerHTML;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    if (chillerCOP.trim() !== this.chillerCOP) {
      this.FreshAirChanged = 'Y';
      const bodyparm = new HttpParams()
        .set('user_id', this.currentId.toString())
        .set('proj_id', this.newProjId.toString())
        .set('hvac', '"' + hvacct + '"')
        .set('boilerCOP', boilerCOP)
        .set('chillerCOP', chillerCOP);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/updateHvac.php', bodyparm)
        .subscribe((data) => {});
    }
  }
  getHvac(id) {
    // alert(document.getElementById("btnnew-"+id).innerHTML)
    var hvacct = id;

    var chillerCOP = document.getElementById('btn-' + id).innerHTML;
    var boilerCOP = document.getElementById('btnnew-' + id).innerHTML;

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    if (boilerCOP.trim() !== this.boilerCOP) {
      this.FreshAirChanged = 'Y';
      const bodyparm = new HttpParams()
        .set('user_id', this.currentId.toString())
        .set('proj_id', this.newProjId.toString())
        .set('hvac', '"' + hvacct + '"')
        .set('boilerCOP', boilerCOP)
        .set('chillerCOP', chillerCOP);
      this.http
        .post(this.rootDomainUrl + 'adeos/api/updateHvac.php', bodyparm)
        .subscribe((data) => {});
    }
  }

  onTogDomHwValChange(event) {
    this.changeDomestic = true;
    if (this.isDhwSelected == event.target.checked) {
      this.dhwToggleChanged = true;
    } else {
      this.dhwToggleChanged = false;
    }
    if (event.target.checked) {
      this.authService.changeToggleStatusDhw('false');
      this.contentEditableHw = false;

      (<HTMLElement>document.querySelector('#inletTemp')).style.border =
        '1px solid #e8edef';
      (<HTMLElement>document.querySelector('#outletTemp')).style.border =
        '1px solid #e8edef';
      (<HTMLElement>document.querySelector('#requirement')).style.border =
        '1px solid #e8edef';
    } else {
      this.contentEditableHw = true;

      this.authService.changeToggleStatusDhw('true');
      (<HTMLElement>document.querySelector('#inletTemp')).style.border =
        '1px solid #dd9b50';
      (<HTMLElement>document.querySelector('#outletTemp')).style.border =
        '1px solid #dd9b50';
      (<HTMLElement>document.querySelector('#requirement')).style.border =
        '1px solid #dd9b50';
    }
  }

  onBlurMethod() {
    var inlet = document.getElementById('inletTemp').innerText;
    var outlet = document.getElementById('outletTemp').innerText;
    var req = document.getElementById('requirement').innerText;

    if (
      this.dhw.inletTemp != inlet ||
      this.dhw.outletTemp != outlet ||
      this.dhw.requirement != req ||
      (this.changeDomestic && this.isDhwSelected)
    ) {
      this.DhwChanged = 'Y';
    } else {
      this.DhwChanged = 'N';
    }
  }

  onBlurMethodOut() {
    //   this.WindChanged = "Y";
  }

  onBlurMethodSolar() {
    var areaPV = document.getElementById('heateng').innerText;
    var eff = document.getElementById('solarEffi').innerText;

    if (
      this.windCost.solarPV[0].areaPV != areaPV ||
      this.windCost.solarPV[0].efficiency != eff ||
      (this.changed && this.isSolarSelected)
    ) {
      this.SolarChanged = 'Y';
    } else {
      this.SolarChanged = 'N';
    }
  }

  onBlurMethodWind() {
    var renew = document.getElementById('renewKwH').innerText;

    if (
      this.windCost.windPower[0].ratedPower != renew ||
      (this.windchangedNew && this.isWindSelected)
    ) {
      this.WindChanged = 'Y';
    } else {
      this.WindChanged = 'N';
    }
  }

  onWindValChange(val) {
    if (val == 'true') {
      this.solarYnWin = 'Yes';
    } else if (val == 'false') {
      this.solarYnWin = 'No';
    }

    //alert(this.solarYnWin)
  }

  uploadHvac(isPrimary) {
    this.hvacVal = [];
    var checkboxeshv = document.querySelectorAll(
      '#hvacitem input[type=checkbox]'
    );

    for (var i = 0; i < checkboxeshv.length; i++) {
      if ((checkboxeshv[i] as HTMLInputElement).value == 'VAV with Reheat') {
        (checkboxeshv[i] as HTMLInputElement).value = 'VAV with Reheat';
      }
      if ((checkboxeshv[i] as HTMLInputElement).value == 'Fan Coil Units') {
        (checkboxeshv[i] as HTMLInputElement).value = 'Fan Coil Units';
      }
      if ((checkboxeshv[i] as HTMLInputElement).value == 'Roof Top Unit') {
        (checkboxeshv[i] as HTMLInputElement).value = 'Roof Top Unit';
      }
      if (
        (checkboxeshv[i] as HTMLInputElement).value == 'Variable Refregent Flow'
      ) {
        (checkboxeshv[i] as HTMLInputElement).value = 'Variable Refregent Flow';
      }
      if (
        (checkboxeshv[i] as HTMLInputElement).value ==
        'Packaged Terminal Air Conditioner'
      ) {
        (checkboxeshv[i] as HTMLInputElement).value =
          'Packaged Terminal Air Conditioner';
      }
      if (
        (checkboxeshv[i] as HTMLInputElement).value == 'Water to Air Heat Pump'
      ) {
        (checkboxeshv[i] as HTMLInputElement).value = 'Water to Air Heat Pump';
      }
      if (
        (checkboxeshv[i] as HTMLInputElement).value == 'Ground Source Heat Pump'
      ) {
        (checkboxeshv[i] as HTMLInputElement).value = 'Ground Source Heat Pump';
      }
      if (
        (checkboxeshv[i] as HTMLInputElement).value ==
        'Air to Air Heat Pump and Backup Heat'
      ) {
        (checkboxeshv[i] as HTMLInputElement).value =
          'Air to Air Heat Pump and Backup Heat';
      }

      this.hvacVal.push((checkboxeshv[i] as HTMLInputElement).value);
    }
    var checkboxeshvSec = document.querySelectorAll(
      '#hvacitemSec input[type=checkbox]'
    );
    for (var i = 0; i < checkboxeshvSec.length; i++) {
      this.hvacVal.push((checkboxeshvSec[i] as HTMLInputElement).value);
    }
    //alert(this.hvacVal)
    this.heatRec = [];
    var checkboxesheat = document.querySelectorAll(
      '#heatRec input[type=checkbox]:checked'
    );
    for (var i = 0; i < checkboxesheat.length; i++) {
      this.heatRec.push((checkboxesheat[i] as HTMLInputElement).value);
    }
    //alert(this.heatRec)

    this.dcv = [];
    var checkboxesdcv = document.querySelectorAll(
      '#dcvval input[type=checkbox]:checked'
    );
    for (var i = 0; i < checkboxesdcv.length; i++) {
      this.dcv.push((checkboxesdcv[i] as HTMLInputElement).value);
    }

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }
    var typeId = 1;
    if (isPrimary) typeId = 1;
    else typeId = 2;

    const bodynew = new HttpParams()
      .set('user_id', this.currentId.toString())
      .set('proj_id', this.newProjId.toString())
      .set('hvac_sys', encodeURIComponent(this.hvacVal.toString()))
      .set('type_id', typeId.toString());
    //.set('heat_recovery', this.heatRec.toString())
    //.set('dcv', this.dcv.toString())

    this.http
      .post(this.rootDomainUrl + 'adeos/api/upload_hvac_temp.php', bodynew)
      .subscribe((data) => {
        // console.log(data)
      });

    //alert(this.dcv)
  }
  uploadLighting() {
    this.lightingVal = [];

    for (var i = 0; i < this.lightData.projLists.length; i++) {
      if (this.lightData.projLists[i].lpd != null)
        this.lightingVal.push(this.lightData.projLists[i].lpd);
    }

    this.lightingValSens = [];
    var checkboxeslgtsen = document.querySelectorAll(
      '#lightingitemsen input[type=checkbox]:checked'
    );
    for (var i = 0; i < checkboxeslgtsen.length; i++) {
      this.lightingValSens.push(
        (checkboxeslgtsen[i] as HTMLInputElement).value
      );
    }
    //alert(this.lightingValSens)

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    const bodynew = new HttpParams()
      .set('user_id', this.currentId.toString())
      .set('proj_id', this.newProjId.toString())
      .set('lighting', this.lightingVal.toString())
      .set('daylight_sensor', this.lightingValSens.toString());

    this.http
      .post(this.rootDomainUrl + 'adeos/api/upload_lighting_temp.php', bodynew)
      .subscribe((data) => {});
  }

  uploadInf() {
    this.infVal = [];
    var checkboxeslgt = document.querySelectorAll(
      '#infitem input[type=checkbox]'
    );
    for (var i = 0; i < checkboxeslgt.length; i++) {
      this.infVal.push((checkboxeslgt[i] as HTMLInputElement).value);
    }
   
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    const bodynew = new HttpParams()
      .set('user_id', this.currentId.toString())
      .set('proj_id', this.newProjId.toString())
      .set('inf', this.infVal.toString());

    this.http
      .post(this.rootDomainUrl + 'adeos/api/upload_inf_temp.php', bodynew)
      .subscribe((data) => {});
  }

  uploadBuildingEnvelop() {
    this.wallValue = [];
  
    this.wallInput.forEach((element, index) => 
    {
        if(element.checked) {
        
          this.wallValue.push(element.value);
        }
        }
    );

    // console.log( this.wallValue)

    this.wallValStr = this.wallValue.toString();

    this.wwrValue = [];
    
    this.wwrInput.forEach((element, index) => 
    {
        if(element.checked) {
        
          this.wwrValue.push(element.value);
        }
        }
    );
    //  alert( this.wallValue)

    this.wwrValStr = this.wwrValue.toString();

    this.floorValue = [];
    this.floorInput.forEach((element, index) => 
    {
        if(element.checked) {
        
          this.floorValue.push(element.value);
        }
        }
    );
    // alert( this.floorValue)
    this.floorValStr = this.floorValue.toString();
    this.roofValue = [];
    this.roofInput.forEach((element, index) => 
    {
        if(element.checked) {
        
          this.roofValue.push(element.value);
        }
        }
    );
    //alert( this.roofValue)
    this.roofValStr = this.roofValue.toString();
    //
    //alert( this.roofValStr)
    this.windowValue = [];
    this.windowInput.forEach((element, index) => 
    {
        if(element.checked) {
        
          this.windowValue.push(element.value);
        }
        }
    );

    this.windowValStr = this.windowValue.join("|");

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }
    const bodynew = new HttpParams()
      .set('user_id', this.currentId.toString())
      .set('proj_id', this.newProjId.toString())
      .set('wall', this.wallValStr)
      .set('roof', this.roofValStr)
      .set('floor', this.floorValStr)
      .set('window', this.windowValStr);

    this.http
      .post(
        this.rootDomainUrl + 'adeos/api/upload_builing_envelope_temp.php',
        bodynew
      )
      .subscribe((data) => {
        console.log(data);
      });
  }
  uploadReneablesTemp() {
    this.solarArea = document.getElementById('heateng').innerText;
    this.solarEffi = document.getElementById('solarEffi').innerText;
    this.solarAzi = document.getElementById('solarAzi').innerText;
    this.solarIncl = document.getElementById('solarIncl').innerText;
    this.renewKw = document.getElementById('renewKwH').innerText;
    this.renewHub = document.getElementById('renewHub').innerText;
    

    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.currentId = this.newEventId;
    } else {
      this.currentId = this.newUserId;
    }

    const bodynew = new HttpParams()
      .set('user_id', this.currentId.toString())
      .set('proj_id', this.newProjId.toString())
      .set('solar_area_of_pv', this.solarArea)
      .set('solar_efficiency', this.solarEffi)
      .set('solar_azimuth', this.solarAzi)
      .set('solar_inclination', this.solarIncl)
      .set('wind_rated_kW', this.renewKw)
      .set('wind_hub_height', this.renewHub)
      .set('wind_angle', ' ')
      .set('wind_efficiency', ' ')
      .set('solar_y_n', this.solarYn.toString())
      .set('wind_y_n', this.solarYnWin.toString())
      .set('solar_cost', this.solarCostValue)
      .set('wind_cost', this.windCostValue);

    this.http
      .post(
        this.rootDomainUrl + 'adeos/api/upload_renewables_temp.php',
        bodynew
      )
      .subscribe((data) => {});
  }

  runval() {
    var nrt = (document.getElementById('Ultra') as HTMLInputElement).value;
    this.nrtVal = nrt;

    if (nrt == 'Electricity') {
      this.effivalue = 100;
    }
    if (nrt == 'Gas') {
      this.effivalue = 80;
    }
    this.nrtVal = nrt;
    var efciy = document.getElementById('efciy').innerText;

    if (this.dhw.efficiency != this.effivalue) {
      this.DhwChanged = 'Y';
    } else {
      this.DhwChanged = 'N';
    }
  }

  custBase() {
    if (document.getElementById('Ultra') != undefined) {
      var nrt = (document.getElementById('Ultra') as HTMLInputElement).value;
      //this.nrtVal = nrt;

    /*  var nrt1;
      if (nrt == this.buildEnv.projLists[0].wall) {
        nrt1 = this.w1;
      } else if (nrt == this.buildEnv.projLists[1].wall) {
        nrt1 = this.w2;
      } else if (nrt == this.buildEnv.projLists[2].wall) {
        nrt1 = this.w3;
      } else if (nrt == this.buildEnv.projLists[3].wall) {
        nrt1 = this.w4;
      } else if (nrt == this.buildEnv.projLists[4].wall) {
        nrt1 = this.w5;
      } else if (nrt == this.buildEnv.projLists[5].wall) {
        nrt1 = this.w6;
      } else if (nrt == this.buildEnv.projLists[6].wall) {
        nrt1 = this.w7;
      }*/

      this.authService.changecustBase(nrt);
    }
}

  CustBaseRoof() {
    if (document.getElementById('Ultratwo') != undefined) {
      var nrt = (document.getElementById('Ultratwo') as HTMLInputElement).value;
     /* var nrt1;
      if (nrt == this.buildEnv.projLists[0].roof) {
        nrt1 = this.r1;
      } else if (nrt == this.buildEnv.projLists[1].roof) {
        nrt1 = this.r2;
      } else if (nrt == this.buildEnv.projLists[2].roof) {
        nrt1 = this.r3;
      } else if (nrt == this.buildEnv.projLists[3].roof) {
        nrt1 = this.r4;
      } else if (nrt == this.buildEnv.projLists[4].roof) {
        nrt1 = this.r5;
      }
*/
      this.authService.changecustBaseRoof(nrt);
    }
  }

  CustBaseFloor() {
    if (document.getElementById('Ultrathree') != undefined) {
      var nrt = (document.getElementById('Ultrathree') as HTMLInputElement)
        .value;
    /*  var nrt1;
      if (nrt == this.buildEnv.projLists[0].floor) {
        nrt1 = this.f1;
      } else if (nrt == this.buildEnv.projLists[1].floor) {
        nrt1 = this.f2;
      } else if (nrt == this.buildEnv.projLists[2].floor) {
        nrt1 = this.f3;
      }
*/
      this.authService.changecustBaseFloor(nrt);
    }
  }

  CustBaseWindow() {
    if (document.getElementById('UltraFour') != undefined) {
      var nrt = (document.getElementById('UltraFour') as HTMLInputElement)
        .value;

      this.authService.changecustBaseWindow(nrt);
    }
  }

  CustBaseShading() {
    if (document.getElementById('UltraFive') != undefined) {
      var nrt = (document.getElementById('UltraFive') as HTMLInputElement)
        .value;

      this.authService.changecustBaseShading(nrt);
    }
  }

  CustBaseLighting() {
    if (document.getElementById('UltraSeven') != undefined) {
      var nrt = (document.getElementById('UltraSeven') as HTMLInputElement)
        .value;

      this.authService.changecustBaseLighting(nrt);
    }
  }
  CustBaseInf() {
    if (document.getElementById('UltraInf') != undefined) {
      var nrt = (document.getElementById('UltraInf') as HTMLInputElement).value;



      this.authService.changecustBaseInf(nrt);
    }
  }
  CustBaseWwr() {
    if (document.getElementById('UltraSix') != undefined) {
      var nrt = (document.getElementById('UltraSix') as HTMLInputElement).value;

      this.authService.changecustBaseWwr(nrt);
    }
  }

  CustBaseDaylight() {
    if (document.getElementById('UltraEight') != undefined) {
      var nrt = (document.getElementById('UltraEight') as HTMLInputElement)
        .value;

      this.authService.changecustBaseDaylight(nrt);
    }
  }
  CustBaseHvac() {
    if (document.getElementById('UltraNine') != undefined) {
      var nrt = (document.getElementById('UltraNine') as HTMLInputElement)
        .value;

      this.authService.changecustBaseHvac(nrt);
    }
  }
    
  getDefVal(ev) {
    this.keycount++;
    if (this.keycount == 1) {
      this.defv = +ev.target.innerText;
    }
    //  console.log(this.defv)

    if (this.defv !== ev.target.innerText) {
      ev.target.style.color = 'red';
    }
  }

  getText(ev, min, max) {
    if (this.defv == +ev.target.innerText) {
      ev.target.style.color = 'black';
    }

    this.keycount = 0;

    if (ev.target.innerText.indexOf('.') !== -1) {
      var number = ev.target.innerText.split('.');

      if (number.length == 2 && number[1].length > 2) {
        alert('only 2 decimals allowed');
        ev.target.innerHTML = this.defv;
        ev.target.style.color = 'black';
      }
    }
    var nrt = ev.target.id;
    var nrtval = nrt.defaultValue;


    if (+ev.target.innerText.indexOf('-') == 0) {
      alert('Negetive values are not allowed');
      // ev.target.innerHTML = "hello"
      ev.target.innerHTML = this.defv;
      ev.target.style.color = 'black';
    }

    if (+ev.target.innerText > max || +ev.target.innerText < min) {
      alert(
        'Please input a number between' +
          '  ' +
          min +
          ' ' +
          'and' +
          ' ' +
          max +
          ' ' +
          'for this field'
      );
      ev.target.innerHTML = this.defv;
      ev.target.style.color = 'black';
    }
    if (isNaN(ev.target.innerText)) {
      alert('Input should be numbers only');
      ev.target.innerHTML = this.defv;
      ev.target.style.color = 'black';
    }
}

  updateHeatCoolInter() {
    if (this.newEmail == 'anuprathi1@gmail.com') {
      this.condId = this.newEventId;
    } else {
      this.condId = this.newUserId;
    }
    if (this.contentEditableWin == false) {
      this.WindEnabled = 'N';
    }
    if (this.contentEditableWin == true) {
      this.WindEnabled = 'Y';
    }
    if (this.contentEditableRen == false) {
      this.SolarEnabled = 'N';
    }
    if (this.contentEditableRen == true) {
      this.SolarEnabled = 'Y';
    }
    if (this.contentEditableHw == true) {
      this.DhwEnabled = 'Y';
    }
    if (this.contentEditableHw == false) {
      this.DhwEnabled = 'N';
    }
    if (this.windToggleChanged == true) {
      this.windToggleChangedFlag = 'Y';
    }
    if (this.windToggleChanged == false) {
      this.windToggleChangedFlag = 'N';
    }
    if (this.solarToggleChanged == true) {
      this.solarToggleChangedFlag = 'Y';
    }
    if (this.solarToggleChanged == false) {
      this.solarToggleChangedFlag = 'N';
    }

    const param = new HttpParams()
      .set('loggedin_user_id', this.newUserId.toString())
      .set('user_id', this.condId)
      .set('proj_id', this.newProjId.toString())
      .set('isSolarChanged', this.SolarChanged)
      .set('isWindChanged', this.WindChanged)
      .set('isFreshAirChanged', this.FreshAirChanged)
      .set('isHeatEffChanged', this.HeatEffChanged)
      .set('isSolarEnabled', this.SolarEnabled)
      .set('isWindEnabled', this.WindEnabled)
      .set('windToggleChanged', this.windToggleChangedFlag)
      .set('solarToggleChanged', this.solarToggleChangedFlag)
      .set('isDhwEnabled', this.DhwEnabled)
      .set('isDhwChanged', this.DhwChanged)
      .set('isCostChanged', 'N');

    if (
      this.SolarChanged == 'Y' ||
      this.WindChanged == 'Y' ||
      this.FreshAirChanged == 'Y' ||
      this.HeatEffChanged == 'Y' ||
      this.solarToggleChanged == true ||
      this.windToggleChanged == true ||
      this.dhwToggleChanged == true ||
      this.DhwChanged == 'Y' ||
      (this.changed && this.isSolarSelected) ||
      (this.windchangedNew && this.isWindSelected) ||
      (this.changeDomestic && this.isDhwSelected)
    ) {
      //end
      console.log('Extrapolation started');
      this.isUpdated = true;
      this.authService.changeisEditable('true');
      console.log(this.isUpdated);
      this.selectedIndex = 0;
      return this.http
        .post(this.rootDomainUrl + 'adeos/api/update_heat_cool.php', param)
        .pipe(map((res) => res))
        .subscribe((data) => {
          console.log(data);
        });
    } else {
      this.isUpdated = false;
      this.authService.changeisEditable('false');
      console.log(this.isUpdated);

      console.log('Extrapolation has not started');
    }
  }

  ngOnInit() {
	  this.authService.changeKpiList([]);
    this.authService.changehideAxisArr([]);
    // console.log(this.windCost.solarPV[0].isSelected)
    this.defaultId = this.authService.demoid;

    this.isLoading = true;

    this.authService.currentFirstLoginVal.subscribe(
      (firstLoginNew) => (this.firstLoginNew = firstLoginNew)
    );
/*    this.authService.currentSelectedWall.subscribe(
      (firstLoginNew) => (this.selectedWall = firstLoginNew)
    );*/
    if (this.firstLoginNew == 'N') {
      document.getElementById('mater').style.display = 'none';
      this.isProjectPresent = false;
    } else {
      this.isProjectPresent = true;
    }

    this.authService.checkUpdateStatus().subscribe((data) => {
      if (data !== null) {
        this.recCount = data;
        //   if(this.recCount.percentage == "100") {
        this.percent = this.recCount.percentage;
        this.time = this.recCount.time;
        for (var i = 0; i < this.recCount.num_records.length; i++) {
          console.log(this.newIsUpdated);
          var recCount = this.recCount.num_records[i].recCount;
          if (
            (recCount != null && recCount >= 0 && recCount < 5184) ||
            this.newIsUpdated == 'Y'
          ) {
            this.isUpdated = true;
            console.log(recCount);
          }
        }
      }
    });

    this.authService.wizardSelectionData().subscribe((data) => {
      if (data !== null) {
        console.log('Wizard selection '+data.projLists[0]);
        this.wallSel = data.projLists[0].wall;
        this.roofSel = data.projLists[0].roof;
        this.floorSel = data.projLists[0].floor;
        this.windowSel = data.projLists[0].window;
        this.wwrSel = data.projLists[0].wwr;
        this.shdSel = data.projLists[0].shading;
        this.dlsSel = data.projLists[0].dl;
        this.infSel = data.projLists[0].infiltration;
        this.heatSel = data.projLists[0].heatRecovery;
        this.hvacSel = data.projLists[0].hvac;
        console.log(this.hvacSel);
        
      }
    });
    this.authService.changecustBaseRoof(' ');
    this.authService.changecustBase(' ');
    this.authService.changecustBaseFloor(' ');
    this.authService.changecustBaseWindow(' ');
    this.authService.changecustBaseShading(' ');
    this.authService.changecustBaseLighting(' ');
    this.authService.changecustBaseInf(' ');
    this.authService.changecustBaseWwr(' ');
    this.authService.changecustBaseHvac(' ');
    this.authService.changecustBaseDaylight(' ');
    this.authService.changeToggleEditable('true');

    this.rootDomainUrl = this.authService.rootDomainUrl;

    this.arrayheatRecNew =
    'heatRecovery' + '=' + '"' + 'Y' + '"' + ',' + '"' + 'N' + '"';    

    this.authService.freshAirData().subscribe((data) => {
      this.freshAir = data;
      if (this.freshAir.success == '1') {
        this.dhw = this.freshAir.DHW[0];
        this.dhwCost = this.dhw.dhw_cost;
        this.effivalue = this.dhw.efficiency;
        if (this.newEmail !== 'demo@ecomatrix.io') {
          if (this.dhw.isSelected == 'true') {
            this.contentEditableHw = true;

            this.isDhwSelected = true;
          } else {
            this.isDhwSelected = false;
          }
        } else {
          this.contentEditableHw = false;
        }

        
        if (this.freshAir.freshAir[0].freshair == 'CUSTOM') {
          this.custv = true;
        }
        for (var i = 0; i < this.freshAir.freshAir.length; i++) {
          if (this.freshAir.freshAir[i].fresh_air_type == '1') {
            this.frAirCbPrim = this.freshAir.freshAir[i].custom;
          } else if (this.freshAir.freshAir[i].fresh_air_type == '2') {
            this.frAirCbSec = this.freshAir.freshAir[i].custom;
          }
        }
      }
    });
    this.authService.hvacData().subscribe((data) => {

      this.hvData = data;

      if (this.hvData.success == '1') {
        var length = this.hvData.projLists.length;
       
        this.selectedCustBaseHvac = this.hvData.projLists[length - 1].primcb;
        this.selectedCustBaseHvacName =
          this.hvData.projLists[length - 1].primcbName;
        this.selectedCustBaseHvacSec = this.hvData.projLists[length - 1].seccb;
        this.selectedCustBaseHvacSecName =
          this.hvData.projLists[length - 1].seccbName;
        this.hvData.projLists.slice(0, length - 1);
        console.log('Selected Hvac' + this.selectedCustBaseHvac);

        this.newhvData = this.hvData;

        //Get custom baseline DHW values
        setTimeout(() => {
          if (this.freshAir && this.freshAir?.DHW.length > 0) {
            for (var i = 0; i < this.freshAir.DHW.length; i++) {
              if (
                this.freshAir.DHW[i].active_hvac_system_id ==
                this.selectedCustBaseHvac
              ) {
                this.custDHW = this.freshAir.DHW[i];
              }
            }

            this.effCust = this.custDHW.efficiency;
            this.srcCust = this.custDHW.DHWSource;
          }
       
        console.log(' selected hvac '+this.hvacSel);
        for (var i = 0; i < this.hvData.projLists.length; i++) {
          if (this.hvData.projLists[i].hvacSysTypeId === '1') {
            console.log(this.hvData.projLists[i]);
            console.log(this.hvData.projLists[i].HVAC_system);
            if(this.hvacSel.includes(this.hvData.projLists[i]?.HVAC_system)) {
              console.log(' In if ');
              this.selectedHvac.push(this.hvData.projLists[i]);
              console.log(this.selectedHvac);
            }
            this.hvacLen++;
            if(this.allHvacSel.length > 0 )
            this.allHvacSel = this.allHvacSel + ',"' + this.hvData.projLists[i].HVAC_system+'"';
            else
            this.allHvacSel =  'hvac' + '="' + this.hvData.projLists[i].HVAC_system+'"';
           // this.HvacNw.push(
            //  '"' + this.hvData.projLists[i].HVAC_system + '"');
          }
          if (
            this.hvData.projLists[i].HVAC_system != '' ||
            this.hvData.projLists[i].HVAC_system != undefined
          ) {
            this.hvacValStr =
              this.hvacValStr + this.hvData.projLists[i].HVAC_system + '",';
          }
          if (this.hvData.projLists[i].hvacSysTypeId === '1') {
            this.hvDataPrimary.push(this.hvData.projLists[i]);
            if (
              this.hvData.projLists[i].HVAC_system ===
              this.selectedCustBaseHvacName
            ) {
              this.mainHtgFuelSrc = this.hvData.projLists[i].mainHtgFuelSrc;
              this.bkupHtgFuelSrc = this.hvData.projLists[i].bkupHtgFuelSrc;
            }
          } else if (this.hvData.projLists[i].hvacSysTypeId === '2') {
            this.hvDataSec.push(this.hvData.projLists[i]);
            this.mainHtgFuelSrc1 = this.hvData.projLists[i].mainHtgFuelSrc;
            this.bkupHtgFuelSrc1 = this.hvData.projLists[i].bkupHtgFuelSrc;
          }
        }
         }, 3000);
        
     //  if (this.newEmail !== 'demo@ecomatrix.io') {
          this.messagenew = this.messagenew + '&hvac=' + this.hvacValStr;
       // }
        //if(this.hvData.success == "1"){
      }
    });

    this.authService.freshAirList().subscribe((data) => {
     
      this.freshAirList = data;
      this.frAirCbPrim = this.freshAirList.baselineData.custom;
      setTimeout(() => {
      //Phase 2.3
      this.arrayheatRecNew =
      'heatRecovery' + '=' + '"' + this.freshAirList?.refData?.YES + '"' + '|' + '"' + this.freshAirList?.refData?.NO + '"';
      if(this.heatSel.includes('Y'))
      this.selectedHeat.push('Y');
      if(this.heatSel.includes('N'))
      this.selectedHeat.push('N');
    }, 3000);
      for (var i = 0; i < this.freshAirList.readData.length; i++) {
        if (this.freshAirList.readData[i].fresh_air_type == '1') {
          this.freshAirPrim.push(this.freshAirList.readData[i]);
        //  this.selectedHeat.push(this.freshAirList.readData[i]);
         // this.heatLen++;
          if (this.freshAirList.readData[i].flow !== '0') {
            this.flowPrimary = this.freshAirList.readData[i].flow;
          }
          console.log('Fresh air list' + this.freshAirList);
          //  if(this.freshAirList.readData[i].active_hvac_system_id == this.selectedCustBaseHvac) {
          console.log(this.frAirCbPrim);
          //Custom baseline fresh air is 'NO'
          if (this.frAirCbPrim == '1') {
            console.log('In frAirCbPrim');
            this.heatCOPPrim =
              this.freshAirList.baselineData.ERVN_Heating_Effectiveness;
            this.coolCOPPrim =
              this.freshAirList.baselineData.ERVN_Cooling_Effectiveness;
            this.heatCbPrim = '-';
            this.coolCbPrim = '-';
            console.log(this.heatCbPrim);
            console.log(this.coolCOPPrim);
          } else {
            this.heatCbPrim =
              this.freshAirList.baselineData.ERVY_Heating_Effectiveness;
            this.coolCbPrim =
              this.freshAirList.baselineData.ERVY_Cooling_Effectiveness;
            this.heatCOPPrim = '-';
            this.coolCOPPrim = '-';
          }
          this.fuelSrcPrim = this.freshAirList.readData[i].htg_fuel_src;
          //  }
        } else if (this.freshAirList.readData[i].fresh_air_type == '2') {
          this.freshAirSec.push(this.freshAirList.readData[i]);
          if (this.freshAirList.readData[i].flow !== '0') {
            this.flowSec = this.freshAirList.readData[i].flow;
          }
          if (
            this.freshAirList.readData[i].active_hvac_system_id ==
            this.selectedCustBaseHvacSec
          ) {
            this.heatCbSec = this.freshAirList.readData[i].heat;
            this.coolCbSec = this.freshAirList.readData[i].cool;
            this.baselineSec = this.freshAirList.readData[i].baseline;
            this.heatCOPSec = this.freshAirList.readData[i].heatingCOP;
            this.coolCOPSec = this.freshAirList.readData[i].coolingCOP;
            this.fuelSrcSec = this.freshAirList.readData[i].htg_fuel_src;
          }
          
        }
      }
    });
    console.log(this.selectedHeat);
    this.SolarChanged = 'N';
    this.WindChanged = 'N';
    this.DhwChanged = 'N';
    this.FreshAirChanged = 'N';
    this.HeatEffChanged = 'N';
	
	 this.authService.humidificationData().subscribe((data) => { 
		this.humidification = data.projLists;
		console.log("humidification");
		console.log(this.humidification);
		for (var i = 0; i < this.humidification.length; i++) {
			if (this.humidification[i].hvac_system_id == this.selectedCustBaseHvac) { 
				this.humAvlbl = this.humidification[i].hum_avlbl;
				this.humCost = this.humidification[i].hum_eff;
				this.humFuelSourceCust = this.humidification[i].hum_fuel_source;
			}
		}
		
	 })
	
    this.authService.renewablesData().subscribe((data) => {
      this.windCost = data;
      if (this.windCost.success == '1') {
        console.log(this.windCost);

        if (this.windCost.solarPV[0].isSelected == 'true') {
          this.contentEditableRen = true;
          this.isSolarSelected = true;
        } else {
          this.isSolarSelected = false;
        }

        if (this.windCost.windPower[0].isSelected == 'true') {
          this.isWindSelected = true;
          this.contentEditableWin = true;
        } else {
          this.isWindSelected = false;
        }

        this.windCostValue = this.windCost.windPower[0].wind_cost;
        this.solarCostValue = this.windCost.solarPV[0].solar_cost;

        if (this.newEmail == 'demo@ecomatrix.io') {
          this.contentEditableRen = false;
        }
      }
     
      //}
    });

    this.nrtVal = 'Electricity';

    //  this.option = "ASHRAE"

    this.custv = false;
    this.authService.currentrequirement.subscribe(
      (newrequirement) => (this.newrequirement = newrequirement)
    );
    this.authService.currentefficency.subscribe(
      (newefficency) => (this.newefficency = newefficency)
    );
    this.authService.currentdhwSource.subscribe(
      (newdhwSource) => (this.newdhwSource = newdhwSource)
    );
    this.authService.currentoutletTemp.subscribe(
      (newoutletTemp) => (this.newoutletTemp = newoutletTemp)
    );
    this.authService.currentinletTemp.subscribe(
      (newinletTemp) => (this.newinletTemp = newinletTemp)
    );
    this.authService.currentwindValue.subscribe(
      (newwindValue) => (this.newwindValue = newwindValue)
    );
    this.authService.currenteffValue.subscribe(
      (neweffValue) => (this.neweffValue = neweffValue)
    );
    this.authService.currentpvValue.subscribe(
      (newpvValue) => (this.newpvValue = newpvValue)
    );
    this.authService.currentcustValue.subscribe(
      (newcustValue) => (this.newcustValue = newcustValue)
    );
    this.authService.currentOptionMsg.subscribe(
      (newOptionMsg) => (this.newOptionMsg = newOptionMsg)
    );
    this.authService.currentUserId.subscribe(
      (newUserId) => (this.newUserId = newUserId)
    );
    this.authService.currenteventId.subscribe(
      (newEventId) => (this.newEventId = newEventId)
    );
    this.authService.currentprojId.subscribe(
      (newProjId) => (this.newProjId = newProjId)
    );
    this.authService.currentisUpdated.subscribe(
      (newIsUpdated) => (this.newIsUpdated = newIsUpdated)
    );
    this.authService.currentClientEmail.subscribe(
      (newEmail) => (this.newEmail = newEmail)
    );
    this.authService.currentcustBaseHtRec.subscribe(
      (newcustHtRec) => (this.newcustHtRec = newcustHtRec)
    );
    this.checkValWindow();

    console.log(this.newEventId);
    console.log(this.newUserId);

   
    this.authService.currentMessage.subscribe(
      (message) => (this.message = message)
    );

    if (this.newEmail == 'demo@ecomatrix.io') {
      this.messagenew =
        'wall="R13.2","R17.58","R22","R26.41"&roof="R35","R47","R60"&floor="F7.5","F15"&window="WIN02","WIN03","WIN05","WIN06"&inf="INF1","INF2","INF3"&shading="NO","YES"&wwr="15%","20%","29%"&dl="DLON","DLOFF"&hvac="NG furnace with DX","Ele furnace with DX","AWHP with ele backup"&heatRecovery="Y","N"';
    } else {
     // this.messagenew =
       // 'wall="W1","W2","W3","W4"&roof="R1","R2","R3"&floor="F1","F2"&window="WIN01","WIN02","WIN03","WIN04","WIN05","WIN06"&inf="INF1","INF2","INF3"&shading="NO","YES"&dl="DLON","DLOFF"&heatRecovery="Y","N"';
    }
console.log('messagenew '+this.messagenew);
    //this.change(e, type)
    const fetchModelValues = this.authService.modelValues();
    if (fetchModelValues) {
      fetchModelValues.subscribe((data: any) => {
        this.modval = data;

        if (this.modval.success == 1) {
           var embCodeUrl =
            this.rootDomainUrl +
            'adeos/api/getEmbedUrl.php?user_id=' +
            this.modval.usrLists[0].user_id +
            '&proj_id=' +
            this.modval.usrLists[0].proj_id;
          return this.http
            .get(embCodeUrl)
            .pipe(map((res) => res))
            .subscribe((data) => {
              console.log(data);
              this.ebmbededCode = data;
              if (this.ebmbededCode['embed_url'] == undefined) {
                this.ebmbededCode['embed_url'] = 'Please upload model';
              }
            });
        }

        if (this.modval.success == 3) {
          // alert("No existing data found. Please upload a file")
          // this.router.navigate(['/logedin']);
        }
      });
    }
    this.authService.renewablesData().subscribe((data) => {
      this.rewval = data;

      if (this.rewval > 0) {
        this.windCostValue = this.rewval.projLists[0].wind_cost;
        this.solarCostValue = this.rewval.projLists[0].solar_cost;
      }
    });

    this.authService.buildingEnvData().subscribe((data) => {
      this.buildEnv = data;
     
      if (this.buildEnv.projLists.length > 1) {
        let len = this.buildEnv.projLists.length;
        //this.buildEnv.projLists.replace(/\s/g, "");
        this.ashraewall = this.buildEnv.projLists[len-1]?.ashrae.WALL;
        this.necbwall = this.buildEnv.projLists[len-1]?.necb.WALL;

        this.selectedCustBase = this.buildEnv.projLists[len-1]?.custom_baseline.WALL;
       // this.selectedCustBase = this.buildEnv.projLists.find((obj) => obj.wall === this.buildEnv.projLists[len-1]?.custom_baseline.WALL).wall_r_value_ip;
        this.necbwwr = this.buildEnv.projLists[len-1]?.necb.WWR1;

        this.necbWwrVal =
          (this.buildEnv.projLists[len-1]?.necb.WWR1 * 100).toFixed() + '%';
        this.authService.changewwrVal(this.necbwwr);

        this.ashraeroof = this.buildEnv.projLists[len-1].ashrae.ROOF;
        this.necbroof = this.buildEnv.projLists[len-1].necb.ROOF;
        this.selectedCustBaseRoof =
          this.buildEnv.projLists[len-1].custom_baseline.ROOF;

        this.ashraefloor = this.buildEnv.projLists[len-1].ashrae.FLOOR;
        this.necbfloor = this.buildEnv.projLists[len-1].necb.FLOOR;
        this.selectedCustBaseFloor =
          this.buildEnv.projLists[len-1].custom_baseline.FLOOR;
        this.wall = [];
        for (var i = 0; i < this.buildEnv.projLists.length; i++) {
          if(this.buildEnv.projLists[i]?.wall) {
            this.allWallSel =  'wall' + '="' + this.buildEnv.projLists[0].wall_r_value_ip+'"';
           /* if(this.allWallSel.length > 0 )
            this.allWallSel = this.allWallSel + ',"' + this.buildEnv.projLists[i].wall_r_value_ip+'"';
            else
            this.allWallSel =  'wall' + '="' + this.buildEnv.projLists[i].wall_r_value_ip+'"';*/
            this.wall.push(
              '"' + this.buildEnv.projLists[i].wall_r_value_ip + '"');
            this.wallLen++;

            if(this.wallSel.includes(this.buildEnv.projLists[i]?.wall)) {
             
              this.selectedWall.push(this.buildEnv.projLists[i]);
            }
          }
          if(this.buildEnv.projLists[i]?.roof) {
            this.allRoofSel =  'roof' + '="' + this.buildEnv.projLists[0].roof_r_value_ip+'"';
            if(this.roofSel.includes(this.buildEnv.projLists[i]?.roof)) 
            this.selectedRoof.push(this.buildEnv.projLists[i]);
            this.roofLen++;
           /* if(this.allRoofSel.length > 0 )
            this.allRoofSel = this.allRoofSel + ',"' + this.buildEnv.projLists[i].roof_r_value_ip+'"';
            else
            this.allRoofSel =  'roof' + '="' + this.buildEnv.projLists[i].roof_r_value_ip+'"';*/
            this.roof.push(
              '"' + this.buildEnv.projLists[i].roof_r_value_ip + '"');
          }
          if(this.buildEnv.projLists[i]?.floor) {
            this.allFloorSel =  'floor' + '="' + this.buildEnv.projLists[0].floor_r_value_ip+'"';;
            if(this.floorSel.includes(this.buildEnv.projLists[i]?.floor)) 
            this.selectedFloor.push(this.buildEnv.projLists[i]);
            this.flrLen++;
           /* if(this.allFloorSel.length > 0 )
            this.allFloorSel = this.allFloorSel + ',"' + this.buildEnv.projLists[i].floor_r_value_ip+'"';
            else
            this.allFloorSel =  'floor' + '="' + this.buildEnv.projLists[i].floor_r_value_ip+'"';*/
            this.floor.push(
              '"' + this.buildEnv.projLists[i].floor_r_value_ip + '"');
          }
          if(this.buildEnv.projLists[i]?.windows) {
            this.allWindowSel =  'window' + '="' + this.buildEnv.projLists[0].win_r_value_ip+'"';
            if(this.windowSel.includes(this.buildEnv.projLists[i]?.windows)) 
            this.selectedWin.push(this.buildEnv.projLists[i]);
            this.winLen++;
           /* if(this.allWindowSel.length > 0 )
            this.allWindowSel = this.allWindowSel + ',"' + this.buildEnv.projLists[i].win_r_value_ip+'"';
            else
            this.allWindowSel =  'window' + '="' + this.buildEnv.projLists[i].win_r_value_ip+'"';*/
            this.windown.push(
              '"' + this.buildEnv.projLists[i].win_r_value_ip + '"');
          }
          if(this.buildEnv.projLists[i]?.shading) {
            this.allShadingSel =  'shading' + '="' + this.buildEnv.projLists[0].shading+'"';
            if(this.shdSel.includes(this.buildEnv.projLists[i]?.shading)) 
            this.selectedShad.push(this.buildEnv.projLists[i]);
            this.shadLen++;
           /* if(this.allShadingSel.length > 0 )
            this.allShadingSel = this.allShadingSel + ',"' + this.buildEnv.projLists[i].shading+'"';
            else
            this.allShadingSel =  'shading' + '="' + this.buildEnv.projLists[i].shading+'"';
            */
            this.shading.push(
              '"' + this.buildEnv.projLists[i].shading + '"');
          }
          if(this.buildEnv.projLists[i].wwr_percentage !== '0'  && this.buildEnv.projLists[i].wwr_percentage !== undefined ) {
            if(this.wwrSel.includes(this.buildEnv.projLists[i]?.wwr_percentage)) 
            this.selectedWwr.push(this.buildEnv.projLists[i]);
            this.wwrLen++;
            /*if(this.allWwrSel.length > 0 )
            this.allWwrSel = this.allWwrSel + ',"' + this.buildEnv.projLists[i].wwr_percentage+'"';
            else
            this.allWwrSel =  'wwr' + '="' + this.buildEnv.projLists[i].wwr_percentage+'"';*/
            this.allWwrSel =  'wwr' + '="' + this.buildEnv.projLists[0].wwr_percentage+'"';
            this.wwrnew.push(
              '"' + this.buildEnv.projLists[i].wwr_percentage + '"');
          }
          //Changes for making HVAC dynamic
          if (
            this.buildEnv.projLists[i].wwr_percentage != 0 &&
            this.buildEnv.projLists[i].wwr_percentage != undefined
          ) {
            this.wwrVal =
              this.wwrVal +
              (this.buildEnv.projLists[i].wwr_percentage * 100).toFixed(1) +
              '%"';
            if (i < 2) {
              this.wwrVal = this.wwrVal + ',"';
            }
          }
          if (this.newEmail !== 'demo@ecomatrix.io') {
            this.messagenew = this.messagenew + '&wwr=' + this.wwrVal;
          }
          if (this.buildEnv.projLists[i].wall == this.ashraewall) {
            this.buildEnv.projLists[len-1].ashrae.WALL =
              this.buildEnv.projLists[i].wall_r_value_ip;
          }
          if (this.buildEnv.projLists[i].wall == this.necbwall) {
            this.buildEnv.projLists[len-1].necb.WALL =
              this.buildEnv.projLists[i].wall_r_value_ip;
          }
          if (this.buildEnv.projLists[i].roof == this.ashraeroof) {
            this.buildEnv.projLists[len-1].ashrae.ROOF =
              this.buildEnv.projLists[i].roof_r_value_ip;
          }
          if (this.buildEnv.projLists[i].roof == this.necbroof) {
            this.buildEnv.projLists[len-1].necb.ROOF =
              this.buildEnv.projLists[i].roof_r_value_ip;
          }

          if (this.buildEnv.projLists[i].floor == this.ashraefloor) {
            this.buildEnv.projLists[len-1].ashrae.FLOOR =
              this.buildEnv.projLists[i].floor_r_value_ip;
          }

          if (this.buildEnv.projLists[i].floor == this.necbfloor) {
            this.buildEnv.projLists[len-1].necb.FLOOR =
              this.buildEnv.projLists[i].floor_r_value_ip;
          }
          //Phase 2.3
          if (i == 0) {
            this.w1 = this.buildEnv.projLists[i].wall_r_value_ip;
            this.r1 = this.buildEnv.projLists[i].roof_r_value_ip;
            this.f1 = this.buildEnv.projLists[i].floor_r_value_ip;
          } else if (i == 1) {
            this.w2 = this.buildEnv.projLists[i].wall_r_value_ip;
            this.r2 = this.buildEnv.projLists[i].roof_r_value_ip;
            this.f2 = this.buildEnv.projLists[i].floor_r_value_ip;
          } else if (i == 2) {
            this.w3 = this.buildEnv.projLists[i].wall_r_value_ip;
            this.r3 = this.buildEnv.projLists[i].roof_r_value_ip;
            this.f3 = this.buildEnv.projLists[i].floor_r_value_ip;
          } else if (i == 3) {
            this.w4 = this.buildEnv.projLists[i].wall_r_value_ip;
            this.r4 = this.buildEnv.projLists[i].roof_r_value_ip;
          } else if (i == 4) {
            this.w5 = this.buildEnv.projLists[i].wall_r_value_ip;
            this.r5 = this.buildEnv.projLists[i].roof_r_value_ip;
          } else if (i == 5) {
            this.w6 = this.buildEnv.projLists[i].wall_r_value_ip;
          } else if (i == 6) {
            this.w7 = this.buildEnv.projLists[i].wall_r_value_ip;
          }

          /*if (i == 0) {
            this.w1 = this.buildEnv.projLists[i].wall;
            this.r1 = this.buildEnv.projLists[i].roof;
            this.f1 = this.buildEnv.projLists[i].floor;
          } else if (i == 1) {
            this.w2 = this.buildEnv.projLists[i].wall;
            this.r2 = this.buildEnv.projLists[i].roof;
            this.f2 = this.buildEnv.projLists[i].floor;
          } else if (i == 2) {
            this.w3 = this.buildEnv.projLists[i].wall;
            this.r3 = this.buildEnv.projLists[i].roof;
            this.f3 = this.buildEnv.projLists[i].floor;
          } else if (i == 3) {
            this.w4 = this.buildEnv.projLists[i].wall;
            this.r4 = this.buildEnv.projLists[i].roof;
          } else if (i == 4) {
            this.w5 = this.buildEnv.projLists[i].wall;
            this.r5 = this.buildEnv.projLists[i].roof;
          } else if (i == 5) {
            this.w6 = this.buildEnv.projLists[i].wall;
          } else if (i == 6) {
            this.w7 = this.buildEnv.projLists[i].wall;
          }*/
          if(i<3)
          this.buildEnv.projLists[i].wwr_percentage =
            (this.buildEnv.projLists[i].wwr_percentage * 100).toFixed(1) + '%';
          
          this.selectedCustBaseWWR =
            (this.buildEnv.projLists[len-1].custom_baseline.WWR1 * 100).toFixed(1) + '%';
        }
        console.log(this.wwrVal);
        this.array = 'wall' + '=' + this.wall;
        
        //  window ashrae and necb values
        this.disbwallW = this.buildEnv.projLists[len-1].ashrae.WINDOW;
        this.disbwallNW = this.buildEnv.projLists[len-1].necb.WINDOW;
        this.selectedCustBasewin =
          this.buildEnv.projLists[len-1].custom_baseline.WINDOW;
        //  shading ashrae and necb values

        this.disbwallS = this.buildEnv.projLists[len-1].ashrae.SHADING;
        this.selectedCustBaseShading =
          this.buildEnv.projLists[len-1].custom_baseline.SHADING;

        console.log(this.buildEnv.projLists[1].shading);
        console.log(this.buildEnv.projLists[0].shading);
        console.log(
          this.selectedCustBaseShading == this.buildEnv.projLists[1].shading
        );

        this.disbwall = this.buildEnv.projLists[len-1].ashrae.WALL;
        this.disbwallN = this.buildEnv.projLists[len-1].necb.WALL;

        this.disbwallR = this.buildEnv.projLists[len-1].ashrae.ROOF;
        this.disbwallNR = this.buildEnv.projLists[len-1].necb.ROOF;

        this.disbwallF = this.buildEnv.projLists[len-1].ashrae.FLOOR;
        this.disbwallNF = this.buildEnv.projLists[len-1].necb.FLOOR;
      }
    });

    this.authService.lightingData().subscribe((data) => {
      this.lightData = data;
      console.log("this.lightData",this.lightData);
      this.allDlsSel =  'dl' + '="' + this.lightData.projLists[0].daylight_sensor+'"';
      let dlsSelected = this.dlsSel.replace("YES","DLON");
      dlsSelected = dlsSelected.replace("NO","DLOFF");
      if (this.lightData.projLists.length > 1) {
        for (var i = 0; i < this.lightData.projLists.length; i++) {
          
          
          if(this.lightData.projLists[i]?.daylight_sensor) {
            if(dlsSelected.includes(this.lightData.projLists[i]?.daylight_sensor)) 
            this.selectedDls.push(this.lightData.projLists[i]);
            this.dlsLen++;

           /* if(this.allDlsSel.length > 0 )
            this.allDlsSel = this.allDlsSel + ',"' + this.lightData.projLists[i].daylight_sensor+'"';
            else
            this.allDlsSel =  'dl' + '="' + this.lightData.projLists[i].daylight_sensor+'"';*/
            
         //   this.Dls.push(
           //   '"' + this.lightData.projLists[i].daylight_sensor + '"');
          }
          if (this.lightData.projLists[i].daylight_sensor == 'DLON') {
            this.lightData.projLists[i].daylight_sensor = 'YES';
          }
          if (this.lightData.projLists[i].daylight_sensor == 'DLOFF') {
            this.lightData.projLists[i].daylight_sensor = 'NO';
          }
        }
        if (this.lightData.projLists[2].ashrae.dls == 'DLOFF') {
          this.lightData.projLists[2].ashrae.dls = 'NO';
        }
        if (this.lightData.projLists[2].ashrae.dls == 'DLON') {
          this.lightData.projLists[2].ashrae.dls = 'YES';
        }
        this.selectedCustBaseLight =
          this.lightData.projLists[2].custom_baseline.lighting;
        console.log(this.selectedCustBaseLight);
        if (this.lightData.projLists[2].custom_baseline.dls == 'DLON') {
          this.selectedCustBaseDaylight = 'YES';
        } else {
          this.selectedCustBaseDaylight = 'NO';
        }
        this.disbwallL = this.lightData.projLists[2].ashrae.lighting;
        this.disbwallNL = this.lightData.projLists[2].necb.lighting;
        this.proposedLight = this.lightData.projLists[3].proposed;
        this.refLight = this.lightData.projLists[3].reference;
        this.disbwallD = this.lightData.projLists[2].ashrae.dls;
      }
    });

    this.authService.infiltrationData().subscribe((data) => {
      this.infData = data;
      if (this.infData.projLists.length > 1) {
        this.selectedCustBaseInf =
          this.infData.projLists[3].custom_baseline.inf;
        this.ashraeInf = this.infData.projLists[3].ashrae.inf;
        this.necbInf = this.infData.projLists[3].necb.inf;
        for (var i = 0; i < this.infData.projLists.length; i++) {
          if(this.infData.projLists[i]?.inf) {
            if(this.infSel.includes(this.infData.projLists[i]?.inf)) 
            this.selectedInf.push(this.infData.projLists[i]);
            this.infLen++;
            if(this.allInfSel.length > 0 )
            this.allInfSel = this.allInfSel + ',"' + this.infData.projLists[i].infiltration_ref+'"';
            else
            this.allInfSel =  'inf' + '="' + this.infData.projLists[i].infiltration_ref+'"';
           // this.inf.push(
            //  '"' + this.infData.projLists[i].infiltration_ref + '"');
          }
        }
      }
   
    });
    this.authService.tediOptionsData().subscribe((data) => {
      this.tediOptionsData = data;
      if (this.tediOptionsData.tediOptions) {
        this.tedi = this.tediOptionsData.tediOptions.tedi;
        this.energy = this.tediOptionsData.tediOptions.energy;
		console.log(this.tedi);
		console.log(this.energy);
		this.authService.changeshowEnergy(this.energy);
		this.authService.changeshowTedi(this.tedi);
      }
    });
    this.authService.categoryCustomizationData().subscribe((data) => {
      this.catCustData = data;
      if (this.catCustData.projLists) {
        this.actualName = this.catCustData.projLists[0].actual_name;
        this.custName = this.catCustData.projLists[0].customized_name;
        if(this.custName.length > 0)
        console.log(this.actualName);
        console.log(this.custName);
        this.authService.changeActualName(this.actualName);
		    this.authService.changeCustName(this.custName);
      }
    });
    setTimeout(() => {
      document.getElementById('mater').style.display = 'none';
      this.isLoading = false;
    }, 3000);
    this.authService.newchartBeCost('Yes');
  }
  
  newMessage() {
    this.authService.changeMessage(
      this.array +
        '&' +
        this.arrayroof +
        '&' +
        this.arrayfloor +
        '&' +
        this.arraywindow +
        '&' +
        this.arrayInf +
        '&' +
        this.arrayshading +
        '&' +
        this.arraywwr +
        '&' +
        this.arraydls +
        '&' +
        this.arrayHvac +
        '&' +
        this.arrayheatRecNew
    );
  }

  myNbc() {
    if (
      this.freshAir.freshAir[0].freshair != 'NECB' &&
      this.newEmail !== 'demo@ecomatrix.io'
    ) {
      this.FreshAirChanged = 'Y';
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var element = document.getElementById('nbc');
      var ash = document.getElementById('ashr');

      element.classList.add('freshAirDhwDemo');
      ash.classList.add('freshAirDhwDem');
    } else {
      this.FreshAirChanged = 'N';
    }
    var element = document.getElementById('nbc');
    var ash = document.getElementById('ashr');
    var cust = document.getElementById('custom');
    var frear = document.getElementById('frair');
    element.classList.add('freshAirDhw');
    ash.classList.remove('freshAirDhw');
    cust.classList.remove('freshAirDhw');
    // frear.classList.remove("edit_text");
    frear.classList.remove('edit_text_custom');

    this.custv = false;

    this.authService.changeOptionMessage('NECB');

    //  console.log(frear.innerText)
  }

  myAsh() {
    var element = document.getElementById('nbc');
    var ash = document.getElementById('ashr');
    var cust = document.getElementById('custom');
    var frear = document.getElementById('frair');
    element.classList.remove('freshAirDhw');
    ash.classList.add('freshAirDhw');
    cust.classList.remove('freshAirDhw');
    // frear.classList.remove("edit_text");
    frear.classList.remove('edit_text_custom');

    this.custv = false;
    this.authService.changeOptionMessage('ASHRAE');

    if (
      this.freshAir.freshAir[0].freshair != 'ASHRAE' &&
      this.newEmail !== 'demo@ecomatrix.io'
    ) {
      this.FreshAirChanged = 'Y';
    } else {
      this.FreshAirChanged = 'N';
    }
    // alert(this.custv)
  }
  custBaseHeat(val) {
    this.authService.changecustBaseHtRec(val);
  }
  myCust() {
    if (
      this.freshAir.freshAir[0].freshair != 'CUSTOM' &&
      this.newEmail !== 'demo@ecomatrix.io'
    ) {
      this.FreshAirChanged = 'Y';
    }
    if (this.newEmail == 'demo@ecomatrix.io') {
      var cust = document.getElementById('custom');
      var frear = document.getElementById('frair');
      var ash = document.getElementById('ashr');

      cust.classList.add('freshAirDhwDemo');
      ash.classList.add('freshAirDhwDem');
    } else {
      this.FreshAirChanged = 'N';
    }
    //console.log(this.FreshAirChanged)
    var element = document.getElementById('nbc');
    var frear = document.getElementById('frair');
    var ash = document.getElementById('ashr');
    var cust = document.getElementById('custom');
    element.classList.remove('freshAirDhw');
    ash.classList.remove('freshAirDhw');
    cust.classList.add('freshAirDhw');
    frear.classList.add('edit_text_custom');
    if (this.newEmail !== 'demo@ecomatrix.io') {
      this.custv = true;
    }
    this.authService.changeOptionMessage('CUSTOM');
    console.log(this.newOptionMsg);
  }
  changeCust() {
    var frear = document.getElementById('frair').innerText;
    if (
      this.freshAir.freshAir[0].custom != frear &&
      this.newEmail !== 'demo@ecomatrix.io'
    ) {
      this.FreshAirChanged = 'Y';
    } else {
      this.FreshAirChanged = 'N';
    }
  }
  getFirstHeat(id): void {
    console.log(id);
    this.heat = document.getElementById('heat_' + id).innerHTML;
  }
  onBlurMethodHeat(id): void {
    var heatNew = document.getElementById('heat_' + id).innerHTML;
    var coolNew = document.getElementById('cool_' + id).innerHTML;

    if (this.heat != heatNew) {
      this.HeatEffChanged = 'Y';
      this.authService.changeheatEff(Number(heatNew));
      this.authService.changecoolEff(Number(coolNew));
    }
  }
  getFirstCool(id): void {
    console.log(id);
    this.cool = document.getElementById('cool_' + id).innerHTML;
  }
  onBlurMethodCool(id): void {
    var coolNew = document.getElementById('cool_' + id).innerHTML;
    var heatNew = document.getElementById('heat_' + id).innerHTML;

    if (this.cool != coolNew) {
      this.HeatEffChanged = 'Y';
      this.authService.changecoolEff(Number(coolNew));
      this.authService.changeheatEff(Number(heatNew));
    }
  }
}
